const translations = {
  route: {
    dashboard: 'Tableau de bord',
    orders: 'Commandes',
    brands: 'Enseignes',
    invoices: 'Factures',
    prepaidAccounts: 'Comptes prépayés',
    prepaidAccountView: 'Compte prépayé',
    brandView: 'Vu enseigne',
    profile: 'Mon compte',
    purchase: 'Prise de commande',
    fileMapper: 'File Mapper',
    stocks: 'Gestion des stocks',
    volumeByBuyers: 'Volume par acheteur',
    ratesManagement: 'Gestion des offres',
    notifications: 'Notifications',
    MultiChoiceCards: 'Cartes multi-choix',
    operation: 'Opérations',
    purchaseInfos: 'Information d\'achat',
    buyersManagement: 'Gestion des acheteurs',
    buyersManagementView: 'Gestion de l\'acheteur',
    customers: 'Clients',
    cards: 'Traçabilité des eBons',
    nativeAppUsers: 'App native',
    enrollment: 'Inscription',
    register: 'Inscription',
    newDotationOrder: 'Nouvelle commande',
    dotationOrdersList: 'Liste des commandes et des acomptes',
    newAcompte: 'Faire un acompte',
    cultureSubsidy: 'Subvention culture',
    cultureSubsidyAdmin: 'Subvention culture'
  },
  navbar: {
    logOut: 'Déconnexion de market',
    logOutWalleo: 'Déconnexion de market et compte Walleo',
    dashboard: 'Tableau de bord',
    profile: 'Mon compte'
  },
  login: {
    title: 'Formulaire de connexion',
    logIn: 'Se connecter',
    username: 'Email',
    password: 'Mot de passe',
    passwordConfirmation: 'Confirmation du mot de passe',
    any: 'quelconque',
    emailError: 'Veuillez saisir une adresse email valide',
    passwordLengthError: 'Le mot de passe doit contenir au moins 6 charactères',
    wrongCredentialsError: 'E-mail ou mot de passe incorrect',
    forgotPassword: 'Mot de passe oublié'
  },
  profile: {
    cardTitle: 'Mon profil',
    tabs: {
      account: {
        title: 'Compte',
        personalInfo: 'Informations personnelles',
        firstname: 'Prénom',
        lastname: 'Nom',
        email: 'Email',
        password: 'Mot de passe',
        changePassword: 'Modifier le mot de passe',
      }
    }
  },
  dashboard: {
    selectPeriod: "Sélectionnez une période",
    periods: {
      lastMonth: 'Mois dernier',
      today: "Aujourd'hui",
      week: 'Cette semaine',
      month: 'Ce mois-ci',
      year: 'Cette année'
    },
    stats: {
      stat1: 'API / Commandes',
      stat2: 'Montant VF',
      stat3: 'Commission',
    },
    volumesBarChart: {
      title: 'Volumes',
      options: {
        buy: "d'achat",
        sell: 'vente'
      },
      volumesBy: {
        total: 'Total',
        giftCards: 'Enseignes',
        buyers: 'Acheteurs'
      }
    },
    leaderboardChart: {
      title: 'Top des',
      options: {
        giftCards: 'enseignes',
        buyers: 'acheteurs'
      },
    },
    table: {
      ref: 'Réf.',
      amount: 'Montant',
      faceValue: 'Valeur faciale',
      commissionRate: 'Taux de commission HT',
      commissionHT: 'Commission HT',
      commissionTTC: 'Commission TTC',
      date: 'Date',
    },
    hello: 'Bonjour',
    connectedAs: 'Connecté en tant que',
    activityBlock: {
      title: 'Activité',
      subtitle: 'Consultez chaque colonne pour plus de détails',
      turnover: 'chiffre d\'affaires',
      ordersNotProcessed: 'commandes à traiter',
      ordersNotDelivered: 'commandes à livrer',
      ordersUnpaid: 'commandes non payées'
    },
    ordersBlock: {
      title: 'Commandes',
      subtitle: 'Commandes nécéssitant une intervention de votre part',
      noPaymentRecorded: 'Aucun paiement enregistré',
      orderNotProceed: 'La commande n\'a pas été passée en traitement'
    },
    prepaidAccountBlock: {
      prepaidAccount: 'solde disponible',
      creditWaiting: 'avoirs en attente'
    }
  },
  orders: {
    header: {
      title: 'Suivi des commandes',
      subtitle: 'Retrouvez vos commandes sur cette interface',
      btnSwitchToBuyer: 'Voir mes commandes acheteur',
      btnSwitchToSeller: 'Voir mes commandes fournisseur'
    },
    splittedTable: {
      btnSplit: 'Mode fractionné',
      table1: 'Commandes en acheteur',
      table2: 'Commandes en fournisseur',
    },
    buyer: {
      filters: {
        filterBtn: 'Filtrer mes commandes',
        title: 'Filtres',
        subtitle: 'Obtenez des meilleurs résultats en utilisant nos filtres intelligents',
        orderNumber: 'Numéro de commande',
        refCustomer: 'Ref. de transaction client',
        timeInterval: 'Intervalle de temps',
        startDate: 'Date de début',
        to: 'à',
        endDate: 'Date de fin',
        status: 'Statut de commande',
        paymentStatus: 'Statut de paiement',
        deliveryStatus: 'Statut de livraison',
        gitfCard: 'Enseignes',
        buyers: 'Acheteurs',
        buyersInfo: 'Applicable uniquement sur la vue commande des acheteurs',
        applyFilters: 'Appliquer les filtres',
        postalCode: 'Code postal',
        postalCodePlaceholder: 'Ex: 75 ou 75000',
        postalCodeHelp: '2 chiffres = département, 5 chiffres = code postal complet',
        situation: 'Situation',
        situationOptions: {
          employee: 'Salarié',
          retired: 'Retraité'
        }
      },
      codes: {
        download: 'Télécharger les codes',
        multipleFiles: 'fichiers de codes sont à télécharger'
      },
      card: {
        ref: 'Ref.',
        buyer: 'Acheteur',
        faceValue: 'Valeur faciale',
        activeFrom: 'Actif à partir du',
        orderPaid: 'Payée',
        orderPaidOn: 'Payée le',
        status: {
          text: 'Statut',
          refunded: 'Remboursée',
          yes: 'Oui',
          partial: 'Partielle',
          no: 'Non',
          inProgress: 'En cours'
        },
        paymentDeadline: 'Échéance de paiement le',
        btnSeeMoreDetails: 'Voir plus de détails',
        exceeding: 'dépassement de',
        orderDelivered: 'Livrée',
        orderDeliveredOn: 'Livrée le',
        detailOrder: 'Veuillez détailler votre commande',
        confirmOrder: 'Confirmer la commande ?',
        proceed: 'Go',
        notNow: 'Pas maintenant',
        processOrder: 'Traiter ma commande',
        waitingDetails: 'En attente de détail',
        btnPaymentWithBalance: 'Payer',
        paymentWithBalanceOptions: {
          opt1: 'Confirmer',
          opt2: 'Annuler'
        },
        orderInfo: {
          phrasing1: "Afin de faciliter l'identification de votre futur paiement de",
          phrasing2: ", merci d'utiliser",
          phrasing3: "comme référence de virement."
        },
        menu: {
          details: 'Détails',
          edit: 'Editer',
          delete: 'Supprimer',
          resume: 'Reprendre',
          suspend: 'Suspendre'
        },
        deleteButtonConfirm: {
          title: 'Êtes-vous sûr de vouloir supprimer cette commande ?',
          opt1: 'Confirmer',
          opt2: 'Annuler'
        },
      }
    },
    seller: {
      header: {
        title: 'Suivi des commandes',
        subtitle: 'Gardez un oeil sur vos livraisons'
      },
      filters: {
        filterBtn: 'Filtrer mes commandes',
        title: 'Filtres',
        subtitle: 'Obtenez des meilleurs résultats en utilisant nos filtres intelligents',
        orderNumber: 'Numéro de commande',
        timeInterval: 'Intervalle de temps',
        startDate: 'Date de début',
        to: 'à',
        endDate: 'Date de fin',
        orderStatus: 'Statut de livraison',
        applyFilters: 'Appliquer les filtres'
      },
      status: {
        complete: 'Livraison complète',
        partial: 'Livraison partielle',
        waiting: 'En attente de livraison',
        errors: {
          title: 'Échec de la livraison',
          details: 'Aucune erreur trouvée | {count} erreur trouvée | {count} erreurs trouvées'
        }
      },
      card: {
        faceValue: 'Valeur faciale',
        progressBarTooltip: 'Vous avez livré un total de {amount} code(s) sur {total} code(s)',
        cardDistributions: 'Détail de la livraison',
        cardDistributionsDetails: 'carte(s) d\'un montant égal à',
        cardDistributionsEmpty: 'Non renseignée',
        deliverCodes: 'Livrer les codes'
      },
      codesDialog: {
        title: 'Téléversement du fichier de codes',
        subtitle: 'Commande #',
        step1: {
          note: 'Assurez-vous que votre fichier de codes ne contient pas d\'erreurs et que votre File Mapper est correctement configuré. La configuration de la date d\'expiration des codes se passe après cette étape.'
        },
        step2: {
          codeActivationDate: 'Date d\'activation des codes',
          placeholderActivationDate: 'Selectionnez une date et un horaire d\'activation des codes',
          note: 'Une fois la date d\'activation des codes renseignée, votre fichier sera prêt à être traité.',
          warning: 'Attention, après avoir cliqué sur "Confirmer la livraison" les codes sont intégralement mis à disposition du client.',
          cancelBtn: 'Annuler',
          confirmBtn: 'Confirmer la livraison',
          processingBtn: 'Traitement...'
        },
        step3: {
          deliveryErrors: {
            title: 'La livraison a échoué',
            subtitle: 'Le fichier que vous venez de télécharger contient des erreurs. Vérifiez aussi que le File Mapper utilisé est correct. Retrouvez les erreurs ci-dessous',
            backToOrderBtn: 'Revenir aux commandes',
            newDeliveryBtn: 'Nouvelle livraison'
          },
          deliverySuccess: {
            title: 'La commande #{number} a été livrée',
            codeActivationDate: 'Les codes seront actifs à partir du :',
            backToOrderBtn: 'Revenir aux commandes'
          }
        },
        deliveryCodesDetails: {
          title: 'Voir les détails de la livraison'
        },
        manageFileMapper: {
          title: 'Gérer mes File Mappers',
          byDefaultBtn: 'Mettre par défaut',
          notification: {
            success: {
              title: 'File Mapper mis à jour',
              subtitle: 'Le file mapper par défaut a été mis à jour'
            },
            error: {
              title: 'Erreur dans le File Mapper',
              subtitle: 'Impossible de changer le File Mapper par défaut'
            }
          }
        },
        handleDeliveryErrors: {
          title: 'Un total de {amount} erreurs ont été trouvées lors de la livraison',
          subtitle: '- Veuillez corriger les erreurs avant de refaire une livraison',
          moreDetailsBtn: '- Afficher plus de détails',
          errorLine: 'Erreur ligne'
        }
      },
      rules: {
        activationDateRequired: 'Date d\'activation requise',
        codeFileRequired: 'Fichier de codes requis'
      }
    },
    wholesaler: {
      btnWholesalerOrders: 'Commandes des fournisseurs',
      btnSeeBuyersOrders: 'Commandes des acheteurs',
      btnLaunchDelivery: 'Livrer la commande',
      seller: 'Fournisseur',
    },
    notification: {
      delete: {
        title: 'Opération réussie',
        message: 'Suppression effectuée'
      },
      resumeSuccess: {
        title: 'Succès',
        message: 'La commande a été mise en cours de traitement'
      },
      resumeError: {
        title: 'Erreur',
        message: 'La commande n\'a pas pu être mise en cours de traitement'
      },
      suspendSuccess: {
        title: 'Succès',
        message: 'La commande a été suspendue'
      },
      suspendError: {
        title: 'Erreur',
        message: 'La commande n\'a pas pu être suspendue'
      },
      deliverySuccess: {
        title: 'Commande en livraison',
        message: 'La livraison de la commande est lancée'
      },
      deliveryError: {
        title: 'Impossible de livrer la commande',
        message: 'La livraison n\'a pas pu être lancée'
      },
      downloadError: {
        title: 'Le téléchargement à échoué',
        message: 'Une erreur s\'est produite lors du téléchargement'
      }
    },
    noMore: 'Vous êtes arrivé à la fin',
    noResults: 'Aucun résultat',
    btnMore: 'Charger plus de commandes'
  },
  invoices: {
    header: {
      title: 'Mes factures',
      subtitle: 'Retrouvez vos factures émises pour chaque commande',
      type: {
        seeInvoicesOfBtn: 'Voir les factures',
        buyers: 'acheteurs',
        sellers: 'vendeurs'
      },
      filters: {
        filterBtn: 'Filtrer mes factures',
        title: 'Filtres',
        subtitle: 'Obtenez des meilleurs résultats en utilisant nos filtres intelligents',
        paymentMode: 'Mode de paiement',
        invoicePer: 'Mode de facturation',
        invoicePerOrder: 'À la commande',
        invoicePerMonth: 'Mensuelle',
        paymentModePrepaid: 'Prépayé',
        paymentModeDiffered: 'Différé',
        invoiceNumber: 'Numéro de facture',
        timeInterval: 'Intervalle de temps',
        startDate: 'Date de début',
        to: 'au',
        endDate: 'Date de fin',
        paymentStatus: 'Statut de paiement',
        orderNumber: 'N° de commande',
        sellers: 'Vendeurs',
        buyers: 'Acheteurs',
        applyFilters: 'Appliquer les filtres'
      },
      extractInvoicesBtn: 'Extraction des factures'
    },
    table: {
      col2: 'Date',
      col3: 'N° Facture',
      col4: 'Mode de facturation',
      col5: 'Montant',
      col6: 'Statut',
      seeMoreBtn: 'Voir plus de factures'
    },
    asidePanel: {
      title: 'Détails de la facture',
      closeBtn: 'Fermer',
      multiBrands: 'Multi enseignes',
      overpaymentOf: 'Trop-perçu de',
      underpaidOf: 'Restant dû de',
      type: 'Type de facture',
      standard: 'Standard',
      commission: 'Commission',
      issuedOn: 'Émise le',
      dueDate: 'Échéance',
      payment: 'Paiement',
      amountToBePaid: 'Montant total',
      balance: 'Solde dû',
      number: 'N°',
      commentComponent: {
        comment: 'Commentaire',
        placeholder: 'Tapez ici pour ajouter un commentaire...',
        notSpecified: 'Aucun commentaire',
        btnAdd: 'Ajouter un commentaire',
        btnEdit: 'Editer',
        btnSave: 'Sauvegarder',
        btnCancel: 'Annuler',
        notification: {
          success: {
            title: 'Succès',
            subtitle: 'Commentaire mis à jour'
          },
          error: {
            title: 'Erreur',
            subtitle: 'Une erreur s\'est produite'
          }
        }
      },
      seeAndDownloadBtn: 'Voir et télécharger ma facture',
      sendInvoiceBtn: 'Téléverser ma facture',
      modifyInvoiceBtn: 'Modifier ma facture',
      popoverValue: {
        number: {
          title: 'Édition du numéro de facture',
          placeholder: 'Renseignez le numéro de facture',
        },
        customNumber: {
          title: 'Ajouter une référence',
          titleEdit: 'Édition de la référence',
          placeholder: 'Renseignez la référence',
          btn: 'Ajouter une référence',
        },
        error: {
          number: 'Le numéro de facture est requis',
          customNumber: 'La référence est requise',
        }
      },
      paymentStatusResultSubtitles: {
        paid: 'Aucune action requise',
        unpaid: 'Veuillez procéder au paiement',
        late: 'Vous avez un retard de paiement'
      },
      relatedOrders: {
        title: 'Commande(s) liée(s)',
        ref: 'Ref.',
        notSpecified: 'Non renseignée',
        seeMoreBtn: 'Voir plus de commandes',
        inputOrderNumber: 'Numéro de commande'
      },
      relatedBankTransfer: {
        title: 'Virement(s) bancaire(s) lié(s)',
        total: 'Total réglé',
        empty: 'Aucun virement bancaire émis'
      },
      seePaymentProof: 'Consultez la preuve de paiement'
    },
    uploadInvoiceDialog: {
      title: 'Téléverser votre facture',
      invoiceNumber: 'N° de facture',
      invoice: 'Facture',
      mandatoryFieldPDF: '(PDF uniquement)',
      cancelBtn: 'Annuler',
      uploadInvoiceBtn: 'Téléverser ma facture',
      numberIsRequired: 'N° de facture requis',
      fileIsRequired: 'Fichier PDF requis',
      notification: {
        success: {
          title: 'Facture téléverser',
          message: 'La facture a été correctement téléversée'
        },
        error: {
          title: 'Une erreur s\'est produite',
          message: 'La facture n\'a pas pu être téléversée'
        }
      }
    }
  },
  extractInvoicesDialog: {
    title: 'Extraction des factures',
    inputMonths: 'Dates des factures à extraire',
    to: 'à',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    cancelBtn: 'Annuler',
    extractBtn: 'Télécharger l\'extraction en csv',
    notification: {
      error: {
        title: 'Erreur',
      }
    }
  },
  prepaidAccount: {
    header: {
      title: 'Vu d\'ensemble des comptes prépayés',
      subtitle: 'Retrouvez sur cette page les comptes prépayés de vos clients',
      title2: 'Compte prépayé',
      subtitle2: 'Retrouvez sur cette page les mouvements du compte prépayé de votre client',
      stats: {
        stats1: 'solde disponible'
      },
      filters: {
        filterBtn: 'Plus de filtres',
        title: 'Filtres',
        subtitle: 'Obtenez des meilleurs résultats en utilisant nos filtres intelligents',
        orderNumber: 'Numéro de commande',
        timeInterval: 'Intervalle de temps',
        startDate: 'Date de début',
        to: 'au',
        endDate: 'Date de fin',
        giftCard: 'Enseignes',
        seller: 'Vendeur',
        reference: 'Référence',
        reason: 'Motif',
        extraction: {
          title: 'Rapports mensuel',
          subtitle: 'Téléchargez vos rapports sous format csv',
          btn: 'Télécharger',
          notification: {
            error: {
              title: 'Erreur lors de l\'extraction',
              message: 'Renseignez une période'
            }
          }
        },
        applyFilters: 'Appliquer les filtres',
        setGlobalViewBtn: 'Vue globale',
        setSellersViewBtn: 'Vue par fournisseur'
      },
      alert: {
        title: 'alerte de solde',
        dialog: {
          title: 'Ajout d\'une alerte de solde disponible',
          subtitle: 'Un email vous sera envoyé une fois le montant saisi dépassé',
          rules: {
            required: 'Le montant est requis'
          }
        },
        notification: {
          success: {
            title: 'Success',
            subtitle: 'Available balance alert added successfully'
          },
          error: {
            title: 'Error',
            subtitle: 'Balance alert could not be added'
          },
        }
      }
    },
    extractDialog: {
      title: 'Rapports mensuel',
      alert: {
        title: 'Information',
        subtitle: 'Les filtres ne s\'appliquent pas à lors du téléchargement du rapport'
      },
      inputMonths: 'Mois du rapport à télécharger',
      currentMonth: 'Mois en cours',
      cancelBtn: 'Annuler',
      extractBtn: 'Télécharger le rapport en csv',
    },
    table: {
      ref: 'Réf.',
      buyer: 'Acheteur',
      requestId: 'ID Requête',
      giftCard: 'Enseigne',
      bankTransfer: 'Virement bancaire',
      amount: 'Montant',
      faceValue: 'Valeur faciale',
      commissionRate: 'Taux de commission HT',
      commissionHT: 'Commission HT',
      commissionTTC: 'Commission TTC',
      date: 'Date',
      btnMore: 'Voir plus de mouvements',
      btnMoreBalance: 'Voir plus de balance',
      paginationOn: 'sur',
      noResult: 'Aucun résultat'
    },
    processing: 'Traitement'
  },
  stock: {
    header: {
      title: 'Mon stock eBons',
      subtitle: 'Retrouvez les stocks de chacune de vos enseignes',
      stats: {
        stats1: 'Commande(s) à honorer'
      },
      filters: {
        filterBtn: 'Filtrer/Trier le stock',
        title: 'Filtres',
        subtitle: 'Obtenez des meilleurs résultats en utilisant nos filtres intelligents',
        giftCard: 'Enseignes',
        sortStock: 'Trier le stock',
        sortStockSubtitle: 'Triez facilement votre stock pour éviter les ruptures stocks',
        sortBy: 'Trier par',
        options: {
          name: 'Nom de l\'enseigne',
          delivery: 'Achat prioritaire'
        },
        applyFilters: 'Appliquer les filtres'
      }
    },
    card: {
      faceValueStock: 'Stock en valeur faciale',
      modeTooltip: 'Mode d\'approvisionnement',
      orderToFulfill: 'Commande(s) à honorer',
      amountDetails: 'Détail du montant',
      equalAmount: '{quantity} carte d\'un montant égal à {amount} | {quantity} cartes d\'un montant égal à {amount} | {quantity} cartes d\'un montant égal à {amount}',
      subtotal: 'Sous-total',
      createOrderBtn: 'Passer une commande',
      editOrderBtn: 'Éditer la commande',
      faceValue: 'Valeur faciale',
      toOrder: 'À commander',
      availableStock: 'Stock disponible',
      available: 'Disponible',
      sharedStock: 'Stock partagé',
      shared: 'Partagé',
      reservedStock: 'Stock réservé',
      reserved: 'Réservé'
    },
    noMore: 'Vous êtes arrivé à la fin',
    noResults: 'Aucun résultat',
    btnMore: 'Charger plus d\'enseignes',
    notification: {
      success: {
        title: 'Commande créée',
        message: '#{number} a été placée dans vos commandes'
      }
    }
  },
  volumeByBuyers: {
    header: {
      title: 'Volume d\'achat',
      subtitle: 'Visualisez vos volumes d\'achat',
      filters: {
        filterBtn: 'Filtrer les acheteurs',
        title: 'Filtres',
        subtitle: 'Obtenez des meilleurs résultats en utilisant nos filtres intelligents',
        findBuyer: 'Rechercher un acheteur',
        selectYear: 'Sélectionner une année',
        applyFilters: 'Appliquer les filtres'
      }
    },
    table: {
      col1: 'Acheteur',
      col2: 'Taux appliqué',
      col3: 'Volume total',
      col4: 'Volume', // Ex: Volume (2022)
      col5: 'Historique (aperçu)',
      empty: 'Aucun acheteur'
    }
  },
  fileMapper: {
    title: 'Créer un nouveau File Mapper',
    uploadBlock: {
      title: 'Glissez / Déposez votre ficher',
      or: 'Ou',
      title2: 'Cliquez ici pour ouvrir l\'explorateur de fichiers',
      title3: '(Détection automatique des en-têtes de votre fichier)',
      errorMultipleFiles: 'Un seul fichier ne peut être téléchargé',
      errorUnreadbleFile: 'Fichier non supporté'
    },
    manualBtn: 'Ajouter manuellement',
    subtitleManual: 'Ajoutez manuellement les noms de vos en-têtes de colonnes tout en les affectant aux variables correspondantes.',
    table: {
      col1: 'Généré le',
      col2: 'Défaut',
      col3: 'Centimes'
    },
    fileMapperDialog: {
      new: 'Création du File Mapper',
      edit: 'Mettre à jour le File Mapper',
      info: {
        title: 'Information',
        content: 'Les variables Code et Montant sont obligatoires pour générer le File Mapper. Les autres variables disponibles sont optionnelles.'
      },
      requiered: 'Requis',
      selectHeader: 'Sélectionnez un en-tête',
      headerName: 'Nom en-tête',
      columnNumber: 'Numéro de la colonne',
      optional: 'Opt.', // 3 lettres MAX
      code: 'Code',
      amount: 'Montant',
      pinCode: 'Code PIN',
      expiration: 'Expiration',
      configuration: {
        fileFormat: 'Format du fichier',
        fileFormatLabel: 'Votre fichier possède t-il des en-têtes ?',
        additionalSetups: 'Configurations supplémentaires',
        separator: 'Caractère de séparation des colonnes',
        separatorLabel: 'Indiquez le caractère qui sépare chaque colonne de votre fichier',
        byDefault: 'Par défaut:',
        comma: 'virgule',
        dateFormat: 'Format de la date',
        dateFormatLabel: ' Renseignez le format de la date d\'éxpiration',
        year: 'Année',
        month: 'Mois',
        day: 'Jour',
        exemple: 'Exemple',
        switchByDefault: 'File Mapper par défaut',
        switchAmountInCentimes: 'Montant exprimé en centimes'
      },
      cancelBtn: 'Annuler',
      editFileMapper: 'Mettre à jour',
      createFileMapper: 'Créer un File Mapper',
      errors: {
        codeRequiered: 'La variable code doit être assignée',
        amountRequiered: 'La variable montant doit être assignée'
      },
      notification: {
        success: {
          title: 'File Mapper créé',
          subtitle: 'Le File Mapper a été créé avec succès'
        },
        update: {
          title: 'File Mapper mis à jour',
          subtitle: 'Le File Mapper a été mis à jour avec succès'
        },
        error: {
          title: '',
          subtitle: ''
        }
      }
    }
  },
  brands: {
    header: {
      title: 'Enseignes',
      subtitle: 'Retrouvez les informations de vos enseignes',
      productID: 'ID produit',
      filters: {
        giftCard: 'Chercher une enseigne'
      },
    },
    card: {
      copyID: 'Copier ID',
      copyProductID: 'Copier ID produit',
      details: 'Détails'
    },
    table: {
      noMore: 'Vous êtes arrivé à la fin',
      noResults: 'Aucun résultat',
      btnMore: 'Charger plus d\'enseignes',
      paginationOn: 'sur'
    },
    view: {
      generalInformations: 'Informations générales',
      description: 'Description',
      descriptionOnWallet: 'Cette description sera affichée sur la fiche enseigne du Wallet',
      notSpecified: 'Non renseignée',
      baseline: 'Baseline / Signature de l\'enseigne',
      useForPDF: 'Utilisée pour la génération des PDF',
      use: 'Utilisation',
      howToUseEbon: 'Comment utiliser un eBon',
      useEbonOn: 'Utiliser un eBon',
      online: '(en ligne)',
      offline: '(en magasin)',
      termsOfUse: 'Conditions d\'utilisation',
      characteristic: 'Caractéristique',
      cumulativeOnline: {
        title: 'Cumulable en ligne',
        opt1: 'Oui',
        opt2: `jusqu'à`,
        opt3: 'Illimitée',
        opt4: 'Non'
      },
      cumulativeOffline: {
        title: 'Cumulable en magasin',
        opt1: 'Oui',
        opt2: `jusqu'à`,
        opt3: 'Illimitée',
        opt4: 'Non'
      },
      usable: {
        title: 'Utilisation',
        opt1: 'En ligne / en magasin',
        opt2: 'Uniquement en ligne',
        opt3: 'Uniquement en magasin'
      },
      splittable: {
        title: 'Sécable',
        opt1: 'Oui',
        opt2: 'Non'
      },
      validity: {
        title: 'Validité',
        opt1: 'Illimitée'
      },
      pinCode: {
        title: 'Code PIN',
        opt1: 'Oui',
        opt2: 'Non'
      },
      pinCodeConcatenation: {
        title: 'Concaténation code PIN',
        opt1: 'Oui',
        opt2: 'Non'
      },
      api: {
        title: 'API',
        opt1: 'Oui',
        opt2: 'Non (Mode stock)'
      },
      barcodeSymbology: 'Type de code-barres',
      others: 'Autres',
      onlineUrl: 'URL pour accéder à la boutique en ligne',
      linkToAccess: 'Lien pour accéder à la boutique en ligne de l\'enseigne',
      partnerStore: 'Boutique(s) partenaire(s)',
      partnerStoreList: 'Liste des boutiques partenaires pour l\'utilisation des eBons',
      sku: {
        title: 'Valeur(s) liée(s)',
        table: {
          col1: 'Type de valeur',
          col2: 'Valeur',
          col3: 'Valeur libre (minimum)',
          col4: 'Valeur libre (maximum)'
        },
        options: {
          yes: 'Valeur libre',
          no: 'Fixe'
        }
      },
      images: {
        title: `Banque d'image`,
        squareLogo: 'Logo carré',
        squareLogoDetails: 'Taille originale : 250x250px',
        bannerImage: 'Logo bannière',
        bannerImageDetails: 'Taille originale : 550x250px',
        cardImage: 'Image carte',
        cardImageDetails: `Aucune taille par défaut (16/9)`,
        downloadBtn: 'Télécharger'
      },
      period: {
        year: '{year} an | {year} ans | {year} ans',
        month: '{month} mois | {month} mois | {month} mois',
        separator: 'et'
      }
    }
  },
  purchaseInfo: {
    header: {
      title: 'Gestion des taux de commission',
      subtitle: 'Gérer les taux de commission des fournisseurs et des acheteurs'
    },
    stats: {
      title: 'Enseignes en gestion'
    },
    wrapper: {
      giftCardsList: {
        title: 'Enseignes',
        subtitle: 'Aucune enseigne active | Une enseigne active | {total} enseignes actives',
        filters: {
          giftCards: 'Chercher une enseigne',
          sellers: 'Chercher un fournisseur'
        }
      },
      title: 'Gestion des taux de l\'enseigne',
      subtitle: 'Aucun fournisseur trouvé | Un fournisseur trouvé | {total} fournisseurs trouvés',
      sellersList: {
        btnAddSeller: 'Ajouter un fournisseur',
        titleBtnOpen: `Voir plus d'informations`,
        titleBtnClose: `Voir moins d'informations`,
        lastUpdate: 'Dernière modification',
        never: 'Jamais',
        informations: {
          title: 'Informations générales du fournisseur',
          col1: 'Taux de commission',
          col2: 'Paiement de la TVA',
          col3: 'Mode de paiement de la commission',
          col4: 'Mode de paiement de la TVA',
          col5: 'Mode de règlement au fournisseur',
          col6: 'API',
          col7: 'Mode de facturation'
        },
        characteristicDeferred: {
          title: 'Caractéristiques du paiement différé',
          col1: 'Plafond du différé',
          col2: 'Différé utilisé',
          col3: 'Délai de paiement',
          col4: 'Conditions',
        },
        buyersTable: {
          title: 'Informations des acheteurs',
          btnAdd: 'Ajouter un acheteur',
          col1: 'Acheteur',
          col2: 'Taux de commission',
          col3: 'Marge',
          col4: 'TVA',
          col5: 'Mode de compensation de la commission',
          col6: 'Mode de paiement'
        }
      }
    },
    rateChangeSchedule: {
      popover: {
        title: 'Planification du taux',
        inputBuyer: 'Choisir un acheteur',
        inputAmount: 'Saisissez un taux',
        inputTime: 'Choisissez un jour et une heure',
        btnSave: 'Enregistrer',
        btnAdd: 'Planifier un taux',
        rules: {
          buyer: 'L\'acheteur est requis',
          amount: 'Le montant est requis',
          time: 'La date et l\'heure sont requises',
        },
        notification: {
          success: {
            title: 'Taux planifié',
            subtitle: 'Le taux a été planifié avec succès'
          },
          update: {
            title: 'Mise à jour',
            subtitle: 'Le taux planifié a été modifié avec succès'
          },
          error: {
            title: 'Erreur',
            subtitle: 'Le taux n\'a pas pu être planifié'
          }
        }
      },
      card: {
        title: 'Taux planifié',
        on: 'le',
        notification: {
          success: {
            title: 'Succès',
            subtitle: 'Le taux planifié a été supprimé'
          },
          error: {
            title: 'Erreur',
            subtitle: 'Le taux planifié n\'a pas pu être supprimé'
          }
        }
      }
    }
  },
  buyersManagement: {
    header: {
      title: 'Gestion des acheteurs',
      subtitle: 'Gérez le solde de vos différents acheteurs',
      btnAdd: 'Ajouter un acheteur'
    },
    stats: {
      title: 'Acheteurs en gestion'
    },
    card: {
      remainingBalance: 'solde disponible',
      btnTopup: 'Créditer',
      btnEditDetails: 'Éditer / Détails'
    },
    table: {
      noMore: 'Vous êtes arrivé à la fin',
      noResults: 'Aucun résultat',
      btnMore: 'Charger plus d\'acheteurs',
    }
  },
  customers: {
    filters: {
      title: 'Filtres',
      subtitle: 'Obtenez de meilleurs résultats en utilisant nos filtres intelligents',
      cancel: 'Annuler',
      apply: 'Appliquer',
      moreFiltersBtn: 'Plus de filtres',
      firstname: 'Prénom',
      lastname: 'Nom',
      email: 'Email',
      emailDomain: 'Domaine email',
      personalEmail: 'Email personnel',
      personalEmailDomain: 'Domaine email personnel',
      businessEmail: 'Email professionnel',
      businessEmailDomain: 'Domaine email professionnel',
      confirmed: 'Confirmé',
      approval: 'Approbation',
      lockedOnly: 'Afficher uniquement les comptes verrouillés',
      registrationFailureReason: 'Raison de l\'échec d\'enregistrement',
      program: 'Programme',
      dateRange: 'Période',
      dateRangePlaceholder: {
        separator: 'à',
        start: 'Date de début',
        end: 'Date de fin'
      },
      sortByDate: 'Trier par date',
      sortByUpdate: 'Trier par mise à jour',
      sortByName: 'Trier par nom',
      sortByDateOptions: {
        desc: 'Plus récent',
        asc: 'Plus ancien'
      },
      sortByUpdateOptions: {
        desc: 'Plus récent',
        asc: 'Plus ancien'
      },
      sortByNameOptions: {
        asc: 'A-Z',
        desc: 'Z-A'
      },
      confirmedOptions: {
        notConfirmed: 'Non confirmé',
        confirmed: 'Confirmé'
      },
      approvalOptions: {
        waiting: 'En attente',
        verification_failed: 'Échec de vérification',
        verified: 'Vérifié'
      },
      registrationFailureReasonOptions: {
        no_reason: 'Aucune raison',
        bad_email: 'Email invalide',
        domain_unknown: 'Domaine inconnu',
        catch_all_domain: 'Domaine catch-all',
        unknown_email: 'Email inconnu',
        risky_email: 'Email risqué',
        mailgun_failed: 'Échec Mailgun'
      },
      postalCode: 'Code postal',
      postalCodePlaceholder: 'Ex: 75 ou 75000',
      postalCodeHelp: '2 chiffres = département, 5 chiffres = code postal complet',
      situation: 'Situation',
      situationOptions: {
        employee: 'Salarié',
        retired: 'Retraité'
      }
    },
    header: {
      title: 'Gestion des clients',
      subtitle: 'Retrouvez les informations personnelles de vos clients',
      beneficiariesTitle: 'Bénéficiaires',
      beneficiariesSubtitle: 'Suivez et gérez les bénéficiaires de votre programme',
      btnAdd: 'Ajouter un client',
      btnDomains: 'Liste des domaines acceptés',
      btnAddDomain: 'Ajouter un domaine',
      btnAddShort: 'Ajouter',
      btnDomainsShort: 'Domaines acceptés',
      btnImport: 'Importer',
      firstname: 'Prénom',
      lastname: 'Nom',
      email: 'Email',
      domain: 'Domaine',
      emailDomain: 'Domaine de l\'email',
      personalEmail: 'Email personnel',
      personalEmailDomain: 'Domaine email personnel',
      businessEmail: 'Email professionnel',
      businessEmailDomain: 'Domaine email professionnel',
      confirmed: 'Email confirmé (Connexion)',
      approval: 'Approbation',
      dateRange: 'Date de création',
      dateRangePlaceholder: {
        start: 'Date de début',
        end: 'Date de fin',
        separator: 'à'
      },
      program: 'Programme',
      filters: {
        firstname: 'Prénom',
        lastname: 'Nom',
        email: 'Email',
        emailDomain: 'Domaine email',
        personalEmail: 'Email personnel',
        personalEmailDomain: 'Domaine email personnel',
        businessEmail: 'Email professionnel',
        businessEmailDomain: 'Domaine email professionnel',
        confirmed: 'Confirmé',
        approval: 'Approbation',
        registrationFailureReason: 'Raison de l\'échec d\'enregistrement',
        program: 'Programme',
        dateRange: 'Période',
        dateRangePlaceholder: {
          separator: 'à',
          start: 'Date de début',
          end: 'Date de fin'
        },
        sortByDate: 'Trier par date',
        sortByUpdate: 'Trier par mise à jour',
        sortByName: 'Trier par nom',
        sortByDateOptions: {
          desc: 'Plus récent',
          asc: 'Plus ancien'
        },
        sortByUpdateOptions: {
          desc: 'Plus récent',
          asc: 'Plus ancien'
        },
        sortByNameOptions: {
          asc: 'A-Z',
          desc: 'Z-A'
        },
        confirmedOptions: {
          notConfirmed: 'Non confirmé',
          confirmed: 'Confirmé'
        },
        approvalOptions: {
          waiting: 'En attente',
          verification_failed: 'Échec de vérification',
          verified: 'Vérifié'
        },
        registrationFailureReasonOptions: {
          no_reason: 'Aucune raison',
          bad_email: 'Email invalide',
          domain_unknown: 'Domaine inconnu',
          catch_all_domain: 'Domaine catch-all',
          unknown_email: 'Email inconnu',
          risky_email: 'Email risqué',
          mailgun_failed: 'Échec Mailgun'
        }
      },
      export: 'Exporter',
      exportExcel: 'Excel',
      exportCSV: 'CSV',
    },
    table: {
      beneficiary: 'Bénéficiaire',
      email: 'E-mail',
      app: 'App',
      actions: 'Actions',
      countLabel: 'bénéficiaire(s)'
    },
    stats: {
      title: 'Nb de clients :',
      filtered: '{count} clients correspondent à vos filtres',
      noFilter: 'Aucun filtre appliqué'
    },
    card: {
      firstname: 'Prénom',
      lastname: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      zipcode: 'Code postal',
      program: 'Programme',
      confirmedShort: 'Confirmé',
      approved: 'Approuvé',
      yes: 'Oui',
      no: 'Non',
      waiting: 'En attente',
      notSpecified: 'Non spécifié',
      auto: 'Automatique',
      manual: 'Manuel',
      situation: 'Situation',
      retired: 'Retraité',
      employee: 'Salarié',
      confirmedLong: 'Statut de confirmation',
      confirmedOptions: {
        confirmed: 'Confirmé',
        notConfirmed: 'Non confirmé'
      },
      popoverFailure: {
        no_reason: 'Aucune raison',
        bad_email: 'Email invalide',
        domain_unknown: 'Domaine inconnu',
        catch_all_domain: 'Domaine catch-all',
        unknown_email: 'Email inconnu',
        risky_email: 'Email risqué',
        mailgun_failed: 'Échec Mailgun'
      },
      btnEdit: 'Modifier',
      btnDelete: 'Supprimer',
      btnVerify: 'Vérifier',
      btnInvalidate: 'Invalider',
      popConfirmDelete: {
        title: 'Êtes-vous sûr de vouloir supprimer ce client ?',
        confirmBtn: 'Confirmer',
        cancelBtn: 'Annuler'
      },
      popover: {
        titleVerify: 'Vérifier le client',
        titleInvalidate: 'Invalider le client',
        subtitleInvalidate: 'Êtes-vous sûr de vouloir invalider ce client ?',
        subtitleForceVerifyEmail: 'Êtes-vous sûr de vouloir forcer la vérification de l\'email ?',
        subtitleForceVerify: 'Êtes-vous sûr de vouloir forcer la vérification ?',
        subtitleVerify1: 'Voulez-vous vérifier le domaine',
        subtitleVerify2: '?',
        subtitleVerify3: 'Cette action est irréversible.',
        abortBtn: 'Annuler',
        verifyBtn: 'Vérifier'
      },
      locked: 'Compte verrouillé',
      unlocked: 'Compte déverrouillé',
      lockedDescription: 'Verrouiller le compte pour empêcher l\'accès en cas d\'activité suspecte ou de fraude',
      trusted: 'Compte fiable',
      notTrusted: 'Compte non fiable',
      trustedDescription: 'Marquer le compte comme fiable pour qu\'il ne soit plus verrouillé automatiquement',
    },
    pagination: {
      btnMore: 'Voir plus de clients',
      noMore: 'Vous êtes arrivé à la fin',
    },
    notification: {
      delete: {
        success: {
          title: 'Succès',
          subtitle: 'Client supprimé'
        },
        error: {
          title: 'Erreur',
          subtitle: 'Le client n\'a pas pu être supprimé'
        }
      },
      verification: {
        success: {
          title: 'Succès',
          subtitle: 'Client mis à jour'
        },
        error: {
          title: 'Erreur',
          subtitle: 'Le client n\'a pas pu être mis à jour'
        }
      },
      export: {
        success: {
          title: 'Export réussi',
          subtitle: 'Le fichier Excel a été généré avec succès'
        },
        error: {
          title: 'Erreur d\'export',
          subtitle: 'Une erreur est survenue lors de la génération du fichier Excel'
        }
      }
    },
    import: {
      title: 'Importer des clients',
      subtitle: 'Importez vos clients via un fichier CSV ou Excel. Les lignes en erreur n\'empêchent pas la création des autres.',
      columnsTitle: 'Colonnes attendues (séparateur ;)',
      required: 'obligatoire',
      optional: 'optionnel',
      downloadTemplate: 'Télécharger un modèle CSV',
      downloadTemplateExcel: 'Télécharger un modèle Excel',
      acceptHint: 'Formats acceptés : .csv, .txt, .xlsx, .xls',
      loading: 'Import en cours…',
      loadingPrograms: 'Chargement des programmes…',
      uploading: 'Envoi du fichier en cours…',
      uploadingTitle: 'Préparation du fichier',
      cancel: 'Annuler',
      close: 'Fermer',
      submit: 'Importer',
      importAnother: 'Importer un autre fichier',
      resultTitle: 'Import terminé',
      resultErrorTitle: 'Import échoué',
      resultSubtitle: '{success} créé(s), {fails} en échec',
      resultErrorSubtitle: '{fails} ligne(s) en erreur dans le fichier',
      successCount: '{count} client(s) créé(s)',
      failsCount: '{count} ligne(s) en échec',
      fileError: 'Erreur fichier',
      programLabel: 'Programme',
      programPlaceholder: 'Sélectionnez un programme',
      programSelected: 'Programme : {name}',
      selectProgramFirst: 'Sélectionnez un programme pour activer l\'upload',
      noProgram: 'Aucun programme disponible pour cet compte.',
      columns: {
        firstname: 'Prénom',
        lastname: 'Nom',
        email: 'Email',
        phone_number: 'Téléphone'
      },
      notification: {
        doneTitle: 'Import terminé',
        errorTitle: 'Erreur d\'import'
      },
      errors: {
        EMAIL_ALREADY_EXISTS: 'Cet email existe déjà',
        MISSING_EMAIL: 'Email manquant',
        MISSING_FIRSTNAME: 'Prénom manquant',
        MISSING_LASTNAME: 'Nom manquant',
        INVALID_EMAIL_FORMAT: 'Format d\'email invalide',
        PROGRAM_NOT_EXIST: 'Programme introuvable',
        UNSUPPORTED_FILE_FORMAT: 'Format de fichier non supporté',
        UNHANDLED_PARSING_ERROR: 'Erreur de lecture du fichier',
        uploadFailed: 'L\'upload du fichier a échoué',
        loadPrograms: 'Impossible de charger les programmes',
        conflict: 'Conflit pendant l\'import (fichier déjà traité ou import en cours). Réessayez avec un nouveau fichier.',
        generic: 'Une erreur est survenue pendant l\'import',
        network: 'Erreur réseau (HTTP {status})',
        withLine: 'Ligne {line} : {message}',
        unknown: 'Erreur : {code}'
      }
    }
  },
  nativeAppUsers: {
    header: {
      title: 'Utilisateurs de l\'app native',
      subtitle: 'Suivez l\'adoption et l\'activité de l\'application mobile Avantages IEG'
    },
    stats: {
      totalCustomers: 'Clients inscrits',
      connected: 'Connectés à l\'app',
      notConnected: 'Jamais connectés',
      adoptionRate: 'Taux d\'adoption',
      recentConnections: 'Connexions (30 derniers jours)'
    },
    filters: {
      search: 'Rechercher par nom ou email',
      connectionStatus: 'Connexion app native',
      all: 'Tous',
      connected: 'Connectés',
      notConnected: 'Non connectés'
    },
    table: {
      name: 'Nom',
      email: 'Email',
      situation: 'Situation',
      zipcode: 'Code postal',
      nativeApp: 'App native',
      lastConnection: 'Dernière connexion',
      empty: 'Aucun client trouvé'
    },
    pagination: {
      btnMore: 'Voir plus de clients'
    }
  },
  payVat: {
    yes: 'Oui',
    no: 'Non',
    intracom: 'Intracom',
  },
  offset: {
    complete: 'Compensation totale',
    partial: 'Compensation partielle',
    no: 'Pas de compensation',
  },
  partialModeOffset: {
    instantPartial: 'Compensation partielle instantanée',
    differedPartial: 'Compensation partielle différée',
    manualPartial: ' Compensation partielle manuelle',
  },
  vatPayBack: {
    bankTransfer: 'Virement bancaire',
    prepaidAccount: 'Crédit sur compte prépayé',
    instantPartial: ' Compensation partielle instantanée',
    inCommission: 'N/A',
    no: 'Pas de remboursement de la TVA',
  },
  deferredDeadline: {
    atInvoiceReception: 'À réception de facture',
    atEndOfMonth: 'À la fin du mois'
  },
  errorLog: {
    tips: 'Cliquez sur l\'icône avec l\'insecte en haut à droite',
    description: 'Le système de gestion propose un formulaire d\'authentification en Single Page Application, qui améliore l\'expérience utilisateur, mais qui peut aussi augmenter les risques de rencontrer des problèmes avec la page, une simple négligeance peut entraîner un dysfonctionnement de la page. Heureusement Vue propose une méthode pour gérer les exceptions, avec laquelle il est possible de gérer les erreurs et avoir un reporting des exceptions.',
    documentation: 'Introduction'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    showSidebarLogo: 'Sidebar Logo',
    fixedHeader: 'Fixed Header',
    sidebarTextTheme: 'Sidebar Text Theme'
  },
  status: {
    waiting: 'En attente',
    processing: 'En cours',
    fulfilled: 'Complétée'
  },
  orderStatus: {
    waiting: 'En attente de traitement',
    processing: 'En cours de traitement',
    fulfilled: 'Honorée',
    suspended: 'Suspendue',
    open: 'Ouverte',
    cancelled: 'Annulée'
  },
  paymentStatus: {
    refunded: 'Remboursée',
    unpaid: 'Non payée',
    paid: 'Payée',
    late: 'En retard'
  },
  deliveryStatus: {
    delivered: 'Livrée',
    in_delivery: 'Partiellement livrée',
    undelivered: 'Non livrée'
  },
  activeCodes: {
    instant: 'Instantané'
  },
  paymentMode: {
    prepaid: 'Comptant',
    differed: 'Différé',
    monthly: 'Mensuel'
  },
  invoicePer: {
    invoice_per_order: 'À la commande',
    invoice_per_month: 'Mensuelle'
  },
  retrievalMode: {
    title: 'Récupération des codes',
    api_retrieval: 'API',
    file_retrieval: 'Fichier'
  },
  deliveryMode: {
    title: 'Livraison',
    api_delivery: 'API',
    file_delivery: 'Fichier'
  },
  kindPrepaidAccount: {
    vat: 'TVA',
    overpayment: 'Trop payé',
    orderPayment: 'Bulk',
    topup: 'Virement entrant',
    fix: 'Correction',
    pull: 'API',
    orderPaymentCancellation: 'Annulation Bulk',
    topupCancellation: 'Annulation Topup',
    pullRefund: 'Remboursement',
    cardRefund: 'Remb. carte',
    reverseRefund: 'Annulation Remb'
  },
  orderFormDialog: {
    createOrderBtn: 'Passer une commande',
    titleUpdate: 'Edition de la commande',
    titleCreate: 'Créer une commande',
    infoGeneral: 'Informations générales',
    giftCard: 'Enseignes',
    selectGiftCard: 'Selectionnez une enseigne',
    paymentRule: 'Règle de paiement',
    paymentDelay: {
      title: 'Délai de paiement',
      atReception: 'à reception',
      days: 'jours'
    },
    drawingCeiling: {
      title: 'Plafond de tirage',
      unlimited: 'illimité'
    },
    remainingDrawdownLimit: {
      title: 'Plafond de tirage restant',
      unlimited: 'illimité'
    },
    refCustomer: 'Référence de transaction client',
    opt: '(en option)',
    phrasing: {
      line1: 'Indiquez ici la référence de transaction que vous allez utiliser pour votre virement.',
      line2: 'Si non renseignée, veuillez utiliser la référence de commande.'
    },
    retrievalMode: 'Livraison des codes',
    retrievalModeOptions: {
      api: 'API',
      file: 'Fichier'
    },
    retrievalModeHelp: 'Choisissez API si vous voulez que ces codes soient mis en stock afin de les récupérer par API. Choisissez fichier, si vous voulez récupérer les codes via un fichier csv.',
    detailOrder: {
      title: 'Détailler ma commande ?',
      yes: 'Oui',
      no: 'Non'
    },
    formDetails: {
      alert: {
        title: 'Actuellement',
        title2: 'sur une commande de',
        compliant: 'Le détail de votre commande est égal au montant total de la commande en valeur faciale.',
        improper: 'Le détail n\'est pas égal au montant total de la commande en valeur faciale.'
      },
      amountCards: 'Nombre de carte(s)',
      amount: 'Montant (€)',
      amountCardsReserved: 'Carte(s) à réserver',
      tooltipCardsReserved: 'La quantité de carte en statut à réserver sera réservé pour approvisionner manuellement ou automatiquement les commandes fermées des acheteurs',
      requiredQuantity: 'Quantité requise',
      amountRequired: 'Montant requis',
    },
    summary: {
      title: 'Vous disposez actuellement de',
      title2: 'sur votre solde.',
      title3: 'Souhaitez vous l\'utiliser pour cette commande ?',
      balanceToUse: 'Solde à utiliser',
      btnMax: 'Max',
      amountDetails: 'Détails du montant à payer',
      faceValue: 'Valeur faciale',
      commissionTTCPercentage: 'Commission TTC en %',
      commissionTTCValue: 'Commission TTC en valeur',
      commissionHT: 'Commission HT',
      credit: 'Avoir',
      creditTips: 'Avoir correspondant à la TVA sur la commission de distribution.',
      amountAfterDiscount: 'Montant après remise',
      prepaidAccount: 'Solde disponible',
      defferedUsage: 'Usage différé',
      remainingAmount: 'Montant restant dû',
      haveCredited: 'Avoir crédité',
      pendingPayment: 'Avoir en attente de versement'
    },
    rules: {
      requiredGiftCard: 'Enseigne requise',
      requiredAmount: 'Le montant de la commande est requis',
      detailsNotEqual: 'Le total du détail n\'est pas égal au montant de la commande'
    },
    notification: {
      create: {
        title: 'Commande créée',
        message: 'La commande a été créée avec succès'
      },
      update: {
        title: 'Commande mise à jour',
        message: 'La commande a été mise à jour'
      },
      error: {
        title: 'Commande non créée',
        message: 'Une erreur est survenue'
      },
      delete: {
        title: 'Commande supprimée',
        message: 'La commande a été supprimée avec succès'
      }
    },
    btnOrder: 'Commander',
    btnUpdate: 'Modifier'
  },
  deliveries: {
    card: {
      title: 'Livraisons',
      btnSee: 'Détail / Téléchargement',
      totalOfCodes: 'Total des codes',
      totalOfCodesByAPI: 'Distribués par API',
      totalOfCodesByFile: 'Distribués par Fichier',
      file: 'Fichier',
      downloaded: 'Téléchargé',
      yes: 'Oui',
      partially: 'Partiellement',
      no: 'Non'
    },
    dialog: {
      title: 'Mes livraisons',
      files: {
        codeFileBlank: 'Aucun fichier généré',
        status: {
          title: 'Statut',
          generated: 'Prêt a être téléchargé',
          notGenerated: 'Non généré',
        },
        detail: {
          title: 'Détail de la livraison',
        },
        download: {
          firstDownload: 'Téléchargé la première fois le',
          lastDownload: 'Téléchargé la dernière fois le',
        },
        btn: {
          launchDownload: 'Télécharger le fichier',
          generatePDFBtn: 'Générer les PDF des cartes',
          fileGenerating: 'Génération du fichier...',
          generateAndDonwload: 'Générer et télécharger le fichier',
          confirm: {
            title: 'Êtes vous sur de vouloir générer un fichier de codes sans PDF ?',
            opt1: 'Annuler',
            opt2: 'Confirmer',
          }
        }
      }
    }
  },
  createBuyerDialog: {
    createTitle: 'Création d\'un acheteur',
    updateTitle: 'Mise à jour d\'un acheteur',
    nameInput: `Nom de l'acheteur`,
    codeInput: 'Préfixe acheteur',
    rcsInput: 'RCS',
    intraVatNumberInput: 'N° TVA Intracommunautaire',
    sirenInput: 'Siren',
    createNewAccount: 'Créer un compte utilisateur pour cet acheteur',
    accountFirstNameInput: 'Prénom',
    accountLastNameInput: 'Nom',
    accountEmailInput: 'Email',
    title2: 'Informations secondaires',
    logoInput: `Logo de l'acheteur`,
    locationNameInput: 'Raison sociale',
    locationLine1Input: 'Adresse',
    locationLine2Input: `Complément d'adresse`,
    locationZipCodeInput: 'Code postal',
    locationCityCodeInput: 'Ville',
    locationStateCodeInput: 'Pays',
    abortBtn: 'Annuler',
    confirmBtn: `Créer l'acheteur`,
    updateBtn: `Mettre à jour`,
    createAccountBtn: `Créer le compte`,
    rules: {
      name: `Le nom de l'acheteur est requis`,
      code: 'Le préfixe acheteur est requis',
      rcs: 'Le RCS est requis',
      intraVatNumber: 'Le N° TVA Intracommunautaire est requis',
      siren: 'Le siren est requis',
      locationName: 'La raison sociale est requise',
      locationLine1: `L'adresse est requise`,
      locationZipCode: 'Le code postal est requis',
      locationCity: `La ville est requise`,
      locationState: 'Le pays est requis',
      firstname: 'Le prénom est requis',
      lastname: 'Le nom de famille est requis',
      email: `L'email est requis`,
    },
    notifications: {
      success: {
        title: 'Acheteur créé',
        subtitle: `L'acheteur a été créé avec succès`
      },
      error: {
        title: 'Erreur',
        subtitle: `L'acheteur n'a pas pu être crée`
      },
      successUpdate: {
        title: 'Acheteur mis à jour',
        subtitle: `L'acheteur a été mis à jour avec succès`
      },
      successAccount: {
        title: 'Compte créé',
        subtitle: `Le compte pour l'acheteur a été créé`
      },
      errorAccount: {
        title: 'Erreur',
        subtitle: `Le compte n'a pas pu être créé`
      }
    }
  },
  topupBuyerDialog: {
    title: 'Ajout de solde pour',
    amountInput: 'Montant (€)',
    referenceInput: 'Référence du virement',
    sendAtInput: 'Effectué le',
    sendAtPlaceholder: 'Sélectionnez date et horaire',
    abortBtn: 'Annuler',
    confirmBtn: 'Confirmer',
    rules: {
      amount: 'Un montant est requis',
      reference: 'La référence du virement est requise',
      sendAt: 'La date du virement est requise'
    },
    notifications: {
      success: {
        title: `L'acheteur a été crédité`,
        subtitle: 'crédité le'
      },
      error: {
        title: `Une erreur s'est produite`,
        subtitle: `L'acheteur n'a pas pu être crédité`
      }
    }
  },
  customerDialog: {
    approvedAuto: 'Client approuvé automatiquement',
    approvedManual: 'Client approuvé manuellement',
    createTitle: 'Nouveau client',
    updateTitle: `Mise à jour d'un client`,
    firstnameInput: 'Prénom',
    lastnameInput: 'Nom',
    businessEmailInput: 'Email professionnel',
    checkEmailBtn: 'Vérifier l\'email',
    emailInput: 'Email de connexion',
    zipcodeInput: 'Code postal',
    emailConfirmation: {
      confirmedByEmail: 'Confirmé via email le',
      notConfirmed: 'Email non confirmé',
      confirmedManually: 'Confirmé manuellement',
      validationInProgress: 'est en cours de validation'
    },
    emailConfirmationStatus: {
      title: 'Statut email',
      accepted: 'File d\'attente',
      rejected: 'Rejeté',
      delivered: 'Délivré',
      failed: 'Echoué',
      opened: 'Ouvert',
      clicked: 'Cliqué',
      unsubscribed: 'Désinscrit',
      complained: 'Complaint',
      stored: 'Stocké',
      on: 'le'
    },
    optinNewsletterInput: 'Le client souhaite recevoir des newsletters',
    codeCniegInput: 'Code CNIEG',
    situationInput: 'Situation',
    retired: 'Retraité',
    employee: 'Salarié',
    phoneInput: 'Téléphone',
    programInput: 'Programme',
    abortBtn: 'Annuler',
    confirmBtn: 'Créer le client',
    updateBtn: 'Mettre à jour',
    rules: {
      firstname: 'Le prénom est requis',
      lastname: 'Le nom est requis',
      email: 'L\'email est requis',
      programId: 'Le programme est requis',
    },
    notifications: {
      success: {
        title: 'Succès',
        subtitle: 'Le client à été créé'
      },
      update: {
        title: 'Succès',
        subtitle: 'Le client a été mis à jour'
      },
      error: {
        title: `Une erreur s'est produite`,
        subtitle: `Le client n'a pas pu être créé ou mis à jour`
      },
      checkEmailSuccess: {
        title: 'Succès',
        subtitle: 'L\'email a été vérifié avec le statut :'
      },
      checkEmailError: {
        title: `Une erreur s'est produite`,
        subtitle: `L'email n'a pas pu être vérifié`
      }
    }
  },
  manageDomainDialog: {
    title: 'Liste des domaines acceptés',
    selectLabelProgram: 'Domaines du programme :',
    selectPlaceholderProgram: 'Sélectionnez un programme',
    domainSearchInput: 'Rechercher un domaine',
    popconfirmDelete: {
      title: 'Êtes-vous sûr de vouloir supprimer ce domaine ?',
      cancelBtn: 'Annuler',
      confirmBtn: 'Confirmer'
    },
    popoverAdd: {
      title: 'Domaine à accepter',
      subtitle: 'Saisissez un domaine à ajouter dans la liste',
      abortBtn: 'Annuler',
      confirmBtn: 'Confirmer',
      addDomainBtn: 'Ajouter un domaine',
      rules: {
        domainRequired: 'Domaine requis',
        domainInvalid: 'Domaine invalide',
      }
    },
    notifications: {
      success: {
        title: 'Succès',
        message: 'Liste de domaine à étè mise à jour'
      },
      error: {
        title: 'Une erreur s\'est produite',
        message: 'Liste de domaine n\'a pas pu être modifier'
      }
    }
  },
  purchaseInfoBuyerDialog: {
    createTitleSeller: `Ajout d'un fournisseur pour`,
    updateTitleSeller: `Mise à jour du fournisseur pour`,
    createTitle: `Assignement d'un acheteur`,
    updateTitle: `Mise à jour d'un acheteur`,
    form: {
      titleInformations: 'Informations générales',
      inputSeller: 'Fournisseur',
      inputBuyer: 'Acheteur',
      inputPayVat: 'Paiement de la TVA',
      inputOffset: 'Mode de compensation',
      inputPartialModeOffset: 'Mode de paiement de la TVA',
      inputDifferedPartialOffset: 'Délai de versement de la TVA (en jour)',
      inputVatPayBack: 'Mode de versement de la TVA',
      inputPaymentMode: 'Mode de paiement',
      titleRate: 'Configuration du taux de commission',
      inputRate: 'Taux de commission (%)',
      titleDeferred: 'Caractéristiques du paiement différé',
      inputDeferredAmountLimit: 'Plafond du différé',
      inputDeferredAmountUsage: 'Différé utilisé',
      inputDeferredDuration: 'Délai de paiement',
      inputInvoiceAt: 'Facturation',
      inputApiEnable: 'API activée ?',
      apiEnableOptions: {
        yes: 'Oui',
        no: 'Non',
      },
      btnCreateSeller: `Ajouter le fournisseur`,
      btnUpdateSeller: `Mettre à jour le fournisseur`,
      btnCreate: `Ajouter l'acheteur`,
      btnUpdate: `Mettre à jour l'acheteur`,
      btnAbort: 'Annuler',
      notification: {
        success: {
          title: `Création des informations d'achat`,
          subtitle: `L'acheteur a été ajouté`
        },
        successSeller: {
          title: `Ajout d'un nouveau fournisseur`,
          subtitle: `Le fournisseur a été ajouté`
        },
        update: {
          title: 'Succès',
          subtitle: `Mise à jour des informations d'achat`
        },
        updateSeller: {
          title: `Succès`,
          subtitle: `Mise à jour des informations d'achat du fournisseur`
        },
        error: {
          title: 'Erreur',
          subtitle: `Une erreur s'est produite lors de l'ajout de l'acheteur`
        },
        errorSeller: {
          title: 'Erreur',
          subtitle: `Une erreur s'est produite lors de l'ajout du fournisseur`
        }
      }
    }
  },
  detailsDialog: {
    ref: 'Ref',
    trackingControl: 'Suivi de livraison',
    subtitle: 'Suivez en temps réél le statut de votre livraison',
    status: {
      undelivered: 'Non livrée',
      inDelivery: 'En livraison',
      complete: 'Livrée'
    },
    codeDeliveries: 'Livraisons des codes',
    deliveriesSubtitle: 'Liste des livraisons des codes relatifs à cette commande',
    deliveriesList: {
      delivery: 'Code livré: {sum} sur {total} | Codes livrés: {sum} sur {total} | Codes livrés: {sum} sur {total}',
      activationDate: 'Date d\'activation',
      inactiveCode: 'Code(s) inactif(s)',
      amountTotal: 'Montant total',
      deliveryDetails: 'Détail de la livraison',
      equalAmount: '{quantity} carte d\'un montant égal à {amount} | {quantity} cartes d\'un montant égal à {amount} | {quantity} cartes d\'un montant égal à {amount}',
      quantityReserved: ', dont {quantityReserved} carte réservée | , dont {quantityReserved} cartes réservées | , dont {quantityReserved} cartes réservées',
      empty: 'Non renseigné',
      downloadFile: 'Télécharger le fichier code en .CSV'
    },
    remainingDraw: 'Tirage restant',
    subtitleDetail: 'Détail de la commande',
    notSpecified: 'Non renseignée',
    downloadStandardInvoiceBtn: 'Télécharger la facture standard',
    downloadCommissionInvoiceBtn: 'Télécharger la facture de commission'
  },
  uploadCodes: {
    errors: {
      CODE_DUPLICATION: 'Code présent en doublon dans le fichier',
      CODE_ALREADY_EXISTS: 'Code déjà livré dans une commande antérieure',
      SKU_NOT_FOUND: 'Valeur faciale non commandée',
      CODE_NOT_ORDERED: 'Code livré en trop',
      UNHANDLED_PARSING_ERROR: 'Le fichier n\'est pas lisible',
      NEGATIVE_AMOUNT: 'Valeur faciale négative',
      MISSING_CODE: 'Code manquant',
      INVALID_EXPIRY_DATE: 'Date d\'expiration invalide'
    },
    found: 'erreur(s) trouvée(s)'
  },
  components: {
    changeLanguageTips: 'Changement de langue effectué',
    copySuccess: 'La valeur a été copiée',
    copyError: 'La valeur n\'a pas pu être copiée'
  },
  common: {
    noData: "Il n'y a pas de données à afficher",
    line: "Ligne",
    copy: "Copier",
    cancel: "Annuler",
    apply: "Appliquer"
  },
  delete: {
    title: 'Voulez-vous vraiment supprimer ceci ?',
    abort: 'Annuler',
    confirm: 'Confirmer',
    notification: {
      success: {
        title: 'Succès',
        subtitle: 'Supprimé avec succès'
      },
      error: {
        title: 'Erreur',
        subtitle: 'Une erreur est survenue'
      }
    }
  },
  roles: {
    seller: 'fournisseur',
    wholesaler: 'grossiste',
    buyer: 'acheteur',
    caretaker: 'concierge'
  },
  gifts: {
    uploadDialog: {
      title: 'Nouvelle campagne de dotation',
      openBtn: 'Importer une campagne de dotation',
      file: 'Fichier CSV ou Excel',
      mandatoryField: '(Formats acceptés : .csv, .xls, .xlsx)',
      mandatoryFieldCSV: '(Formats acceptés : .csv, .xls, .xlsx)',
      fileIsRequired: 'Le fichier est requis',
      cancelBtn: 'Annuler',
      uploadBtn: 'Importer',
      processing: 'Traitement du fichier...',
      preparing: 'Préparation du fichier...',
      updating: 'Mise à jour des données...',
      sending: 'Envoi en cours...',
      importComplete: 'Import terminé',
      cardsCreated: 'carte(s) traitée(s)',
      importErrors: 'erreur(s) d\'import',
      verifyData: 'Veuillez vérifier que les données importées sont correctes. Vous pouvez les modifier si nécessaire avant la soumission finale de la campagne.',
      searchFilters: 'Filtres de recherche',
      clearFilters: 'Effacer les filtres',
      searchBy: 'Rechercher par',
      search: 'Rechercher',
      showOnlyErrors: 'Afficher uniquement les erreurs',
      errorLines: 'ligne(s) avec erreur',
      downloadModifiedCsv: 'Télécharger le CSV modifié',
      changeFile: 'Changer de fichier',
      launchCampaign: 'Lancer la campagne de dotation',
      selectCard: 'Sélectionner une carte',
      confirmation: {
        title: 'Lancer la campagne de dotation',
        subtitle: 'Êtes-vous sûr de vouloir lancer cette campagne de dotation ?',
        confirm: 'Oui, lancer la campagne',
        cancel: 'Non, vérifier à nouveau'
      },
      notification: {
        success: {
          title: 'Succès',
          message: 'Le fichier a été importé avec succès'
        },
        error: {
          title: 'Erreur',
          message: 'Une erreur est survenue lors de l\'import'
        }
      },
      errors: {
        noData: 'Le fichier ne contient aucune donnée',
        noOperation: 'Aucune opération sélectionnée',
        validation: 'Erreur de validation',
        validationWithCode: 'Erreur de validation (422)',
        generic: 'Une erreur est survenue lors du traitement du fichier',
        formValidation: 'Veuillez corriger toutes les erreurs avant de soumettre le formulaire',
        unsupportedFormat: 'Format de fichier non supporté. Utilisez un fichier CSV, XLS ou XLSX.',
        missingHeaders: 'Le fichier ne contient pas tous les champs requis. Champs manquants : {fields}',
        readError: 'Erreur lors de la lecture du fichier',
      },
      csvFormat: {
        title: 'Format attendu du fichier',
        description: 'Le fichier doit contenir les colonnes suivantes (CSV avec séparateur ; ou feuille Excel) :',
        columns: {
          firstname: 'Prénom du bénéficiaire',
          lastname: 'Nom de famille du bénéficiaire',
          email: 'Adresse e-mail',
          multi_choice_gift_card: 'Nom de la carte cadeau',
          amount: 'Montant en euros (Nombre entier)',
          scheduled_at: 'Date d\'envoi (format : jj/mm/aaaa)',
        },
        note: 'Les colonnes CSV doivent être séparées par des points-virgules (;). Pour Excel, utilisez la première feuille du classeur.',
      },
      downloadTemplate: 'Télécharger le modèle CSV',
      downloadTemplateExcel: 'Télécharger le modèle Excel',
      createNewTable: 'Créer un nouveau tableau',
      addRow: 'Ajouter une ligne',
      errorCopied: 'Erreur copiée dans le presse-papier',
      recipientInfo: 'Bénéficiaire',
      emailInfo: 'Email',
      copySuccess: 'Copié dans le presse-papier',
      copyError: 'Impossible de copier dans le presse-papier',
    },
    validation: {
      errors: {
        unknown: 'Erreur inconnue',
        field_required: 'Le champ {field} ne peut pas être vide',
        fieldRequired: 'Le champ {field} est requis',
        invalid_email: 'Format d\'email invalide',
        invalid_gift_card: 'Carte cadeau non disponible dans ce programme',
        invalid_amount: 'Le montant doit être un nombre entier',
        invalid_date: 'La date doit être au format jj/mm/aaaa',
        invalid_date_value: 'Date invalide',
        code_duplication: 'Code(s) en double dans le fichier',
        code_already_exists: 'Code(s) déjà livrés dans une commande précédente',
        sku_not_found: 'Valeur(s) faciale(s) non trouvée(s) dans le détail de la commande',
        code_not_ordered: 'Code(s) supplémentaire(s)',
        unhandled_parsing_error: 'Le fichier n\'est pas lisible',
        negative_amount: 'Valeur(s) faciale(s) négative(s)',
        missing_code: 'Code(s) manquant(s)',
        generic: 'Une erreur est survenue',
        invalidEmail: 'Format d\'email invalide',
        invalidDate: 'La date doit être au format jj/mm/aaaa',
        invalidAmount: 'Le montant doit être un nombre entier',
        invalidGiftCard: 'Carte cadeau non disponible dans ce programme',
        date_in_the_past: 'La date d\'envoi programmée ne peut pas être antérieure à aujourd\'hui',
        scheduledAtPast: 'La date d\'envoi programmée ne peut pas être antérieure à aujourd\'hui'
      }
    },
    extendDialog: {
      title: 'Prolonger l\'expiration',
      tooltip: 'Prolonger l\'expiration',
      notExtendableTooltip: 'Prolongation indisponible pour une carte entièrement utilisée',
      notExtendableBlankTooltip: 'Prolongation indisponible pour une dotation vierge',
      card: 'Carte',
      count: 'Nombre de dotations',
      currentExpiration: 'Expiration actuelle',
      notSet: 'Non renseignée',
      durationLabel: 'Durée de prolongation (jours)',
      durationRequired: 'Indiquez un nombre de jours',
      daysUnit: 'jours',
      lastExtension: 'Dernière prolongation le {date} (+{duration} jours)',
      activePreview: '{count} carte(s) active(s) : expiration actuelle + {days} jours',
      expiredPreview: '{count} carte(s) expirée(s) : aujourd\'hui + {days} jours',
      atomicWarning: 'En cas d\'échec sur une seule carte, aucune prolongation ne sera appliquée (transaction tout ou rien).',
      submitBtn: 'Prolonger',
      confirmTitle: 'Confirmer la prolongation de {days} jours ?',
      notification: {
        success: {
          title: 'Succès',
          message: 'Expiration prolongée de {days} jours'
        },
        error: {
          title: 'Erreur',
          fallback: 'Une erreur est survenue lors de la prolongation'
        }
      }
    },
    extendBulkDialog: {
      title: 'Prolonger plusieurs dotations',
      actionBtn: 'Prolonger {count} dotation(s)',
      confirmTitle: 'Confirmer la prolongation de {days} jours pour {count} dotation(s) ?',
      notification: {
        success: {
          message: 'Expiration prolongée de {days} jours pour {count} dotation(s)'
        }
      }
    },
    redemptionPdf: {
      generateBtn: 'Générer le PDF',
      downloadBtn: 'Télécharger le PDF',
      generateTooltip: `Générer un bon PDF avec un code pour que le bénéficiaire accède à son cadeau`,
      downloadTooltip: 'Télécharger le bon PDF déjà généré',
      notification: {
        error: {
          title: 'Erreur',
          fallback: 'Impossible de générer le PDF'
        }
      }
    },
    resendEmailDialog: {
      title: `Modifier l'email et renvoyer`,
      actionTooltip: `Modifier l'email et renvoyer le cadeau`,
      limitReachedTooltip: 'Limite de 3 renvois atteinte',
      currentEmail: 'Email actuel',
      failureReason: `Raison de l'échec`,
      newEmail: 'Nouvel email',
      invalidEmail: 'Veuillez saisir un email valide',
      accountWarning: `L'email sera modifié sur tout le compte du bénéficiaire (toutes ses cartes).`,
      remaining: 'Renvois restants : {count}',
      closeBtn: 'Annuler',
      submitBtn: 'Renvoyer',
      notification: {
        success: {
          title: 'Email renvoyé',
          message: `Le cadeau a été renvoyé à la nouvelle adresse`
        },
        error: {
          title: 'Erreur',
          fallback: `Impossible de renvoyer l'email`
        }
      }
    },
    revokeDialog: {
      title: 'Annuler la dotation',
      tooltip: 'Annuler la dotation',
      beneficiary: 'Bénéficiaire',
      blankCard: 'Carte vierge',
      card: 'Carte',
      amount: 'Montant',
      emailWarningPreIssue: 'Un email de livraison a déjà été envoyé au bénéficiaire. L\'annulation est possible, mais l\'email ne pourra pas être rappelé.',
      emailWarningDynamic: 'Un email de livraison de la dotation a déjà été envoyé au bénéficiaire. L\'annulation est possible, mais l\'email ne pourra pas être rappelé. Le bénéficiaire pourra cliquer sur le lien envoyé mais aucune dotation ne sera affichée à la connexion.',
      descriptionBlankUnassigned: 'Cette action supprimera cette dotation vierge et créditera votre acompte de dotation. La dotation vierge sera supprimée.',
      descriptionPreIssueAssigned: 'Cette action retirera la dotation à son bénéficiaire. La dotation redeviendra vierge et sera à nouveau disponible pour doter un futur bénéficiaire.',
      descriptionDynamicAssigned: 'Cette action annulera la dotation et créditera votre acompte de dotation. La dotation sera supprimée.',
      notRevocableUsedTooltip: 'Carte utilisée',
      closeBtn: 'Fermer',
      submitBtn: 'Annuler la dotation',
      confirmTitle: 'Confirmer l\'annulation de cette dotation ?',
      notification: {
        success: {
          title: 'Succès',
          message: 'Dotation annulée avec succès'
        },
        error: {
          title: 'Erreur',
          fallback: 'Une erreur est survenue lors de l\'annulation de la dotation'
        }
      }
    },
    revokeBulkDialog: {
      title: 'Annuler plusieurs dotations',
      actionBtn: 'Annuler {count} dotation(s)',
      count: 'Nombre de dotations',
      totalAmount: 'Montant total',
      emailWarning: 'Un email de livraison a déjà été envoyé pour au moins une dotation. L\'annulation reste possible, mais les emails ne pourront pas être rappelés.',
      atomicWarning: 'En cas d\'échec sur une seule carte, aucune dotation ne sera annulée (transaction tout ou rien).',
      descriptionMixed: 'Cette action annulera ou retirera les dotations sélectionnées et créditera votre acompte de dotation selon le type de chaque dotation.',
      closeBtn: 'Fermer',
      submitBtn: 'Confirmer l\'annulation',
      confirmTitle: 'Confirmer l\'annulation de {count} dotation(s) ?',
      notRevocableTooltip: 'Carte utilisée',
      notification: {
        success: {
          title: 'Succès',
          message: '{count} dotation(s) annulée(s)'
        },
        error: {
          title: 'Erreur',
          fallback: 'Une erreur est survenue lors de l\'annulation des dotations'
        }
      }
    }
  },
  enrollment: {
    steps: {
      structure: 'Votre structure',
      bankCards: 'Carte bancaire',
      validation: 'Validation'
    },
    navigation: {
      previous: 'Étape précédente',
      next: 'Étape suivante',
      submit: 'Valider l\'inscription',
      legalNote: 'Inscription 100 % gratuite · En continuant vous acceptez nos conditions générales et notre politique RGPD.'
    },
    common: {
      yes: 'Oui',
      no: 'Non'
    },
    rgpd: {
      title: 'Avant de commencer',
      description: 'Carrefour Pro souhaite transmettre vos données professionnelles à Browse&Go, l\'opérateur du Pass Avantage, afin de pré-remplir votre formulaire d\'inscription et simplifier votre démarche.',
      dataTitle: 'Données concernées :',
      dataList: 'Raison sociale, SIRET, adresse de facturation, coordonnées du contact principal',
      dataDelivery: ', adresses de vos sites de livraison',
      refusalNote: 'En cas de refus, aucune donnée ne sera transmise et vous remplirez le formulaire vous-même. Ce choix n\'affecte pas votre accès au Pass Avantage.',
      accept: 'J\'accepte — pré-remplir mon formulaire',
      refuse: 'Je refuse — je saisirai mes données manuellement'
    },
    prefill: {
      loading: 'Récupération de vos informations…',
      error: 'Impossible de récupérer vos informations. Vous pouvez continuer votre inscription manuellement.',
      prefilledBadge: 'Pré-rempli',
      successBanner: 'Certaines informations ont été pré-remplies. Vérifiez-les avant de continuer.'
    },
    structure: {
      infoBanner: 'Complétez les informations de la structure à inscrire. Les champs marqués « Importé » proviennent d\'une source partenaire.',
      companyTitle: 'Votre structure',
      companySubtitle: 'Informations légales de l\'organisation',
      adminTitle: 'Personne référente',
      adminBadge: 'Administrateur',
      adminSubtitle: 'Ce compte aura les droits admin — il pourra créer d\'autres utilisateurs après l\'inscription',
      adminInfo: 'La personne renseignée ici sera administrateur principal du Pass Avantage. Elle pourra inviter d\'autres membres et gérer les droits d\'accès.',
      billingTitle: 'Adresse de facturation',
      billingSubtitle: 'Pour l\'émission de vos factures',
      invoiceTitle: 'Facturation',
      invoiceSubtitle: 'Comment souhaitez-vous recevoir vos factures ?',
      deliveryTitle: 'Adresses de livraison',
      deliverySubtitle: 'Sites de réception de vos dotations en cartes bancaires physiques (facultatif)',
      legalTitle: 'Conditions générales',
      legalSubtitle: 'À lire et accepter avant de continuer'
    },
    fields: {
      companyName: 'Raison sociale',
      entityKind: 'Type de structure',
      entityKindPlaceholder: '— Choisir —',
      entityKindOther: 'Précisez',
      siret: 'SIRET',
      siretHint: '14 chiffres',
      siren: 'SIREN (facultatif)',
      vatNumber: 'N° TVA intracommunautaire (facultatif)',
      rcs: 'Registre du commerce (facultatif)',
      nafCode: 'Code NAF (facultatif)',
      employeeRange: 'Nombre de salariés (facultatif)',
      employeeRangePlaceholder: '— Fourchette —',
      adminFullName: 'Nom et prénom',
      contactRole: 'Fonction',
      contactRolePlaceholder: '— Sélectionner —',
      contactRoleOther: 'Précisez la fonction',
      adminEmail: 'E-mail professionnel',
      adminEmailHint: 'Cet e-mail sera l\'identifiant de connexion',
      mobilePhone: 'Téléphone mobile',
      landlinePhone: 'Téléphone fixe (facultatif)',
      password: 'Mot de passe',
      passwordConfirmation: 'Confirmer le mot de passe',
      streetNumber: 'Numéro (facultatif)',
      street: 'Voie',
      city: 'Ville',
      zipcode: 'Code postal',
      country: 'Pays',
      invoiceMode: 'Mode de facturation',
      invoiceMonthly: 'Mensuelle',
      invoicePerOrder: 'À la commande',
      acceptedCgu: 'J\'ai lu et j\'accepte les Conditions Générales de vente et d\'utilisation du Pass Avantage.',
      acceptedRgpd: 'J\'accepte le traitement de mes données conformément à la Politique de confidentialité RGPD.',
      optinNewsletter: 'J\'accepte de recevoir les actualités et offres Pass Avantage par e-mail ou SMS. (Facultatif)',
      required: 'Obligatoire'
    },
    password: {
      title: 'Choisissez le mot de passe',
      subtitle: 'Pour le futur espace administrateur',
      hintDefault: 'Minimum 8 caractères, une majuscule, un chiffre',
      tooShort: 'Trop court',
      weak: 'Faible',
      medium: 'Moyen',
      strong: 'Fort',
      matchDefault: 'Doit être identique au mot de passe',
      matchOk: 'Les mots de passe correspondent',
      matchKo: 'Les mots de passe ne correspondent pas'
    },
    delivery: {
      prefillNotice: 'Adresses importées depuis le compte partenaire. Vérifiez-les ci-dessous, vous pouvez les modifier ou en ajouter.',
      emptyHint: 'Si vous prévoyez de commander des cartes bancaires physiques, vous pouvez ajouter vos adresses de livraison dès maintenant ou plus tard.',
      newSite: 'Nouveau site',
      imported: 'Importé',
      siteName: 'Nom du site',
      siteNamePlaceholder: 'Ex. : Siège social, Site de Lyon…',
      street: 'Voie',
      streetPlaceholder: 'Numéro et nom de la voie',
      city: 'Ville',
      cityPlaceholder: 'Ex. : Paris',
      zipcode: 'Code postal',
      zipcodePlaceholder: '75001',
      addSite: 'Ajouter un site de livraison'
    },
    bankCards: {
      standardTitle: 'Dotations standard — conversions disponibles par défaut',
      standardSubtitle: 'Ces options sont actives pour tous vos bénéficiaires sans démarche supplémentaire.',
      ecardCarrefour: 'e-Carte Carrefour',
      ecardEverywish: 'e-Carte multi-enseignes Everywish',
      ecardBank: 'e-Carte Bancaire (option)',
      optionsTitle: 'Options cartes — demandes d\'activation',
      optionsSubtitle: 'Ces options nécessitent une activation par notre service administratif',
      physicalQuestion: 'Envisagez-vous de commander des cartes bancaires physiques ?',
      physicalHint: 'Cochez OUI si vous souhaitez que notre service administratif active cette option. Par défaut : Non.',
      virtualQuestion: 'Envisagez-vous de commander des cartes bancaires virtuelles ?',
      virtualHint: 'Cochez OUI si vous souhaitez que notre service administratif active cette option. Par défaut : Non.',
      adminNotice: 'Vous serez notifié dès que ces options seront activées. Contactez votre chargé d\'affaires le cas échéant.',
      physicalAddressesTitle: 'Adresses de livraison de vos sites',
      physicalAddressesSubtitle: 'Optionnel — vous pourrez les renseigner lors de votre première commande',
      physicalAddressesEmpty: 'Ajoutez au moins une adresse de livraison pour les cartes physiques.'
    },
    validation: {
      recapTitle: 'Récapitulatif de votre inscription',
      deliveryAddresses: 'Adresses livraison',
      deliveryCount: '{count} site(s) renseigné(s)',
      deliveryLater: 'À configurer à la 1ʳᵉ commande',
      deliveryNone: 'Aucune adresse renseignée',
      cardOptionsTitle: 'Options cartes bancaires demandées',
      pending: 'En attente',
      journeyTitle: 'Votre parcours d\'activation — juste après cette étape',
      journeySubtitle: 'Votre espace sera guidé, rien ne sera laissé au hasard',
      journeyEmail: 'Confirmez votre e-mail',
      journeyEmailDesc: 'Un lien vous est envoyé à {email}. Un clic suffit pour activer le compte administrateur.',
      journeyBeneficiaries: 'Importez votre base de bénéficiaires',
      journeyBeneficiariesDesc: 'Importez vos bénéficiaires pour leur ouvrir l\'accès au Programme Avantage et au wallet mobile.',
      journeyBalance: 'Alimentez votre solde d\'acompte',
      journeyBalanceDesc: 'Votre compte démarre avec un solde à zéro. Pour émettre des dotations, vous devrez l\'alimenter.',
      journeyOrders: 'Passez vos premières commandes de dotation',
      journeyOrdersDesc: 'Noël, intéressement, événement d\'entreprise… Commandez depuis votre espace admin, à votre rythme.',
      optional: 'Facultatif'
    },
    success: {
      title: 'Un dernier clic !',
      description: 'L\'inscription est enregistrée. Pour activer le compte administrateur, cliquez sur le lien de confirmation envoyé à',
      carrefourProId: 'ID Carrefour Pro',
      passAvantageId: 'ID Pass Avantage',
      nextBeneficiaries: 'Prochaine étape : chargez votre base de bénéficiaires pour leur ouvrir l\'accès au Programme Avantage.',
      nextBalance: 'Votre solde d\'acompte est à zéro. Vous pourrez l\'alimenter depuis votre espace pour émettre des dotations.',
      noEmail: 'Pas d\'e-mail reçu ? Vérifiez vos courriers indésirables ou contactez notre support.',
      backToCustomers: 'Retour aux clients'
    },
    rules: {
      companyName: 'La raison sociale est requise',
      entityKind: 'Le type de structure est requis',
      entityKindOther: 'Veuillez préciser le type de structure',
      siret: 'Le SIRET est requis',
      siretFormat: 'Le SIRET doit contenir 14 chiffres',
      adminFullName: 'Le nom et prénom sont requis',
      contactRole: 'La fonction est requise',
      contactRoleOther: 'Veuillez préciser la fonction',
      adminEmail: 'L\'e-mail professionnel est requis',
      emailFormat: 'Veuillez saisir une adresse e-mail valide',
      mobilePhone: 'Le téléphone mobile est requis',
      password: 'Le mot de passe est requis',
      passwordFormat: 'Minimum 8 caractères, une majuscule et un chiffre',
      passwordConfirmation: 'La confirmation est requise',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      street: 'La voie est requise',
      city: 'La ville est requise',
      zipcode: 'Le code postal est requis',
      country: 'Le pays est requis',
      siteName: 'Le nom du site est requis',
      legalRequired: 'Veuillez accepter les conditions générales et la politique RGPD pour continuer'
    },
    customersEntry: 'Inscrire une structure'
  },
  newDotationOrder: {
    steps: {
      orderType: 'Type de commande',
      nature: 'Nature de dotation',
      cardOptions: 'Options carte',
      distribution: 'Distribution',
      entry: 'Saisie'
    },
    navigation: {
      previous: 'Étape précédente',
      next: 'Étape suivante',
      submit: 'Valider la commande'
    },
    orderType: {
      intro: 'Sélectionnez le type de dotation que vous souhaitez commander pour vos bénéficiaires.',
      comingSoon: 'Bientôt disponible',
      standard: {
        title: 'Standard au choix du porteur',
        description: 'e-Carte Carrefour + Everywish incluses. Option e-Carte bancaire à l\'étape suivante.'
      },
      physical: {
        title: 'Carte bancaire physique seul',
        description: 'Carte Mastercard prépayée livrée physiquement sur site ou à domicile.'
      },
      virtual: {
        title: 'Carte bancaire virtuelle seul',
        description: 'e-Carte Mastercard prépayée émise instantanément, sans livraison physique.'
      }
    },
    nature: {
      intro: 'Choisissez la nature de votre commande de dotation.',
      urssaf: {
        title: 'Dotation URSSAF',
        description: 'Événements éligibles à l\'exonération de cotisations sociales (Noël, naissance, mariage…). Seuil 2025 : 193 € par événement.'
      },
      classic: {
        title: 'Dotation classique',
        description: 'Dotation libre sans contrainte de montant ni d\'événement.'
      },
      eventLabel: 'Événement',
      eventPlaceholder: '— Sélectionner un événement —'
    },
    event: {
      selected: 'Événement sélectionné : {name}',
      empty: 'Aucun événement URSSAF actif disponible.',
      loadError: 'Impossible de charger les événements URSSAF.'
    },
    cardOptions: {
      includedCarrefour: 'e-Carte Carrefour incluse',
      includedEverywish: 'e-Carte Everywish incluse',
      optional: 'Option',
      bankCardTitle: 'e-Carte bancaire prépayée',
      bankCardHint: 'Liberté totale au porteur — {issuancePrice} / carte + {loadingRate} frais de chargement',
      bankCardHintLoading: 'Liberté totale au porteur — tarification en cours de chargement…',
      fundingQuestion: 'Qui finance le coût de la carte ?',
      fundingBeneficiary: 'Le bénéficiaire (déduit de sa dotation)',
      fundingOrganization: 'L\'organisation (en sus de la dotation)',
      issuanceSubsidyLabel: 'Subvention émission',
      loadingSubsidyLabel: 'Subvention chargement',
      provisionNotice: 'Une provision de 20 % du montant total de la commande vous sera demandée à la validation pour couvrir la subvention des frais e-carte bancaire.'
    },
    distribution: {
      intro: 'Comment souhaitez-vous distribuer les dotations ?',
      single: {
        title: 'Dotation unitaire',
        description: 'Saisie manuelle pour un bénéficiaire. Idéal pour un cas individuel.'
      },
      csv: {
        title: 'Import CSV / Excel',
        description: 'Import de plusieurs bénéficiaires via un fichier. Idéal pour Noël, été, culture…'
      }
    },
    entry: {
      recapTitle: 'Récapitulatif',
      programLabel: 'Programme',
      programPlaceholder: 'Sélectionnez un programme',
      programSelected: 'Programme : {name}',
      noProgram: 'Aucun programme disponible pour cet compte.',
      loadProgramsError: 'Impossible de charger les programmes.',
      beneficiaryCount: 'Nombre de bénéficiaires',
      totalAmount: 'Montant total de dotation',
      beneficiary: 'Bénéficiaire',
      beneficiaryPlaceholder: 'Rechercher un bénéficiaire',
      searchEmail: 'Email',
      firstname: 'Prénom',
      lastname: 'Nom',
      amount: 'Montant (€)',
      amountPlaceholder: '50',
      scheduledAt: 'Date de planification',
      scheduledAtPlaceholder: 'JJ/MM/AAAA',
      scheduledAtOptionalPlaceholder: 'JJ/MM/AAAA (vide = envoi immédiat)',
      clientReference: 'Référence client (optionnel)',
      clientReferencePlaceholder: 'REF-1234',
      csvColumnsTitle: 'Colonnes attendues (séparateur ;)',
      downloadCsvTemplate: 'Télécharger un modèle CSV',
      downloadExcelTemplate: 'Télécharger un modèle Excel',
      csvDrop: 'Déposez le fichier ici ou cliquez pour le sélectionner',
      csvParsing: 'Lecture du fichier…',
      csvReadError: 'Impossible de lire le fichier.',
      csvTable: {
        headers: {
          firstname: 'Prénom',
          lastname: 'Nom',
          gender: 'Genre',
          email: 'Email',
          amount: 'Montant (€)',
          scheduled_at: 'Programmé le',
          scheduledAtFormat: 'JJ/MM/AAAA',
          customer_client_reference: 'Référence client'
        },
        addRow: 'Ajouter une ligne',
        deleteRow: 'Supprimer la ligne',
        changeFile: 'Supprimer et importer un nouveau fichier',
        originalFile: 'Fichier d\'origine : {filename}',
        rowError: 'Ligne {line} — {field} : {message}',
        modifiedMessage: 'Voulez-vous générer le fichier excel correspondant ?',
        downloadModified: 'Télécharger la nouvelle version',
        errors: {
          missingFirstname: 'Prénom requis',
          missingLastname: 'Nom requis',
          missingEmail: 'Email requis',
          invalidEmail: 'Format d\'email invalide',
          invalidAmount: 'Montant invalide (nombre entier positif requis)',
          invalidDate: 'Date invalide (format JJ/MM/AAAA)',
          dateInThePast: 'La date ne peut pas être dans le passé',
          customerNotFound: 'Aucun bénéficiaire existant ne correspond à cet email'
        }
      }
    },
    success: {
      title: 'Commande enregistrée',
      description: 'Votre commande de dotation a été créée.',
      reference: 'Référence commande',
      total: 'Montant total',
      counts: '{success} ligne(s) créée(s), {fails} en échec',
      failsDetailTitle: 'Lignes en échec',
      failRow: 'Ligne {rowNumber} : {message}',
      backToOrders: 'Voir le détail de ma commande de dotation'
    },
    rules: {
      nature: 'La nature de dotation est requise',
      urssafEvent: 'L\'événement est requis pour une dotation URSSAF',
      cardFunding: 'Veuillez indiquer qui finance la e-carte bancaire',
      distributionMode: 'Le mode de distribution est requis',
      program: 'Le programme est requis',
      customer: 'Le bénéficiaire est requis',
      amount: 'Le montant doit être supérieur à 0',
      scheduledAt: 'La date de planification est requise',
      csv: 'Le fichier d\'import est requis',
      csvInvalidRows: 'Corrigez les lignes en erreur avant de continuer'
    },
    notification: {
      errorTitle: 'Erreur',
      errorGeneric: 'La commande n\'a pas pu être créée.',
      csvRowError: 'Ligne {line} : {message}',
      partialTitle: 'Commande créée avec des erreurs',
      partialMessage: '{success} succès, {fails} échec(s).',
      classicUnavailable: 'La création de commandes classiques n\'est pas encore disponible via l\'API. Choisissez une dotation URSSAF.'
    },
    headerCta: 'Nouvelle commande de dotation'
  },
  dotationOrders: {
    breadcrumb: {
      dashboard: 'Tableau de bord',
      current: 'Liste des commandes et des acomptes'
    },
    title: 'Liste des commandes et des acomptes',
    subtitle: 'Suivez vos commandes de cartes multi-choix et vos acomptes',
    scheduledAt: 'Date d\'envoi',
    budget: {
      total: 'Solde acompte',
      available: 'Solde acompte disponible',
      reserved: 'Solde réservé',
      reservedOrdersLabel: 'Commande(s) attachée(s) :'
    },
    newOrderCta: 'Nouvelle commande de dotation',
    newAcompteCta: 'Faire un acompte',
    empty: 'Aucune commande ni acompte. Lancez une nouvelle commande de dotation ou faites un acompte.',
    filters: {
      orders: 'Commandes',
      acomptes: 'Acomptes'
    },
    acompte: {
      label: 'Acompte',
      pendingHint: 'Commande d\'acompte libre en attente de paiement, veuillez effectuer votre virement avec la référence suivante : {reference}',
      pendingHintReserved: 'Commande d\'acompte réservé en attente de paiement, veuillez effectuer votre virement avec la référence suivante : {reference}',
      status: {
        pending: 'En attente de virement',
        validated: 'Validé'
      },
      actions: {
        delete: 'Supprimer cet acompte'
      },
      delete: {
        confirmTitle: 'Supprimer cet acompte',
        confirmMessage: 'Supprimer cet acompte ? Cette action est irréversible.'
      }
    },
    status: {
      paid: 'Payé',
      confirmed: 'Confirmé',
      draft: 'Brouillon',
      unpaid: 'En attente de paiement'
    },
    beneficiaries: {
      title: 'Lignes de commande',
      name: 'Bénéficiaire',
      email: 'E-mail',
      amount: 'Montant',
      emailStatus: 'Statut eMail',
      action: 'Action',
      empty: 'Aucune ligne sur cette commande'
    },
    schedule: {
      expiredMessage: 'Cette commande devait être envoyée le {date}, une date déjà passée. Choisissez comment procéder avant de payer :',
      sendNow: 'Envoyer immédiatement',
      applyDate: 'Appliquer cette date',
      datePlaceholder: 'Choisir une nouvelle date',
      rescheduleErrorTitle: 'Erreur de replanification',
      rescheduleError: 'La date d\'envoi n\'a pas pu être mise à jour.'
    },
    actions: {
      pay: 'Payer la commande',
      confirmPayment: 'Confirmer le paiement',
      delete: 'Supprimer la commande',
      confirm: 'Confirmer',
      cancel: 'Annuler'
    },
    paymentMethod: {
      title: 'Moyen de paiement',
      card: 'Carte bancaire',
      cardHint: 'Bientôt disponible',
      transfer: 'Virement affecté',
      transferHint: 'Virement bancaire affecté à cette commande',
      acompte: 'Acompte disponible',
      acompteHint: 'Solde disponible : {amount}',
      acompteReservedHint: 'Dont réservé pour cette commande : {amount}'
    },
    pay: {
      confirmTitle: 'Payer la commande',
      confirmMessage: 'Confirmer le paiement de {amount} pour {count} bénéficiaire(s) ? Les cartes seront émises et le budget débité.',
      banner: 'Cette commande n\'a pas encore été réglée. Le paiement émettra les cartes et débitera le budget.',
      insufficientMessage: 'Votre acompte disponible est insuffisant. Voulez-vous compléter la différence de {amount} par un virement affecté ?',
      emptyMessage: 'Vous n\'avez pas de fonds disponibles sur l\'acompte libre (solde 0 €). Faites un virement d\'approvisionnement d\'acompte libre.',
      completeByTransfer: 'Compléter par virement'
    },
    delete: {
      confirmTitle: 'Supprimer la commande',
      confirmMessage: 'Supprimer cette commande ? Cette action est irréversible.'
    },
    notifications: {
      deleted: 'Commande supprimée.',
      paid: 'Commande payée. Les cartes ont été émises.',
      loadErrorTitle: 'Erreur de chargement',
      loadError: 'Impossible de charger les commandes.',
      deleteErrorTitle: 'Erreur de suppression',
      deleteError: 'La commande n\'a pas pu être supprimée.',
      payErrorTitle: 'Erreur de paiement',
      payError: 'Le paiement a échoué. Vérifiez le budget ou le statut de la commande.',
      acompteDeleted: 'Acompte supprimé.',
      acompteDeleteErrorTitle: 'Erreur de suppression',
      acompteDeleteError: 'L\'acompte n\'a pas pu être supprimé.'
    }
  },
  newAcompte: {
    breadcrumb: {
      current: 'Faire un acompte'
    },
    title: 'Faire un acompte',
    subtitle: 'Déclarez un virement effectué ou à venir. Il sera validé par un administrateur.',
    form: {
      amount: 'Montant',
      comment: 'Motif',
      assignedToOrder: 'Cet acompte sera affecté à la commande {reference}.',
      rules: {
        amount: 'Le montant est obligatoire'
      }
    },
    actions: {
      cancel: 'Annuler',
      submit: 'Valider l\'acompte'
    },
    notifications: {
      success: {
        title: 'Acompte enregistré',
        subtitle: 'Commande d\'acompte libre en attente de paiement, veuillez effectuer votre virement avec la référence suivante : {reference}',
        subtitleReserved: 'Commande d\'acompte réservé en attente de paiement, veuillez effectuer votre virement avec la référence suivante : {reference}'
      },
      error: {
        title: 'Erreur',
        subtitle: 'L\'acompte n\'a pas pu être enregistré.'
      }
    }
  },
  cultureSubsidy: {
    title: 'Subvention culture',
    subtitle: 'Prise en charge partielle des achats culture de vos bénéficiaires, à partir de l’acompte libre.',
    demo: 'Données de démonstration',
    resetDemo: 'Réinitialiser la démo',
    resetDone: 'Données de démonstration réinitialisées',
    breadcrumb: {
      dashboard: 'Tableau de bord',
      current: 'Subvention culture'
    },
    status: {
      active: 'Active',
      disabled: 'Désactivée',
      blocked: 'Bloquée'
    },
    nav: {
      overview: 'Vue d’ensemble',
      settings: 'Règles',
      funding: 'Réserve',
      history: 'Historique',
      products: 'Produits',
      operations: 'Opérations',
      beneficiaries: 'Bénéficiaires'
    },
    gauge: {
      consumed: 'Consommé',
      reserve: 'Réserve disponible',
      fallback: 'Fallback théorique',
      budget: 'Budget paramétré',
      aria: 'Jauge de subvention. Consommé {consumed} €, réserve {reserve} €, fallback {fallback} €, budget {budget} €'
    },
    pockets: {
      culture_reserve: 'Réserve culture',
      loyalty: 'Fidélité',
      free: 'Acompte libre',
      recycling: 'Recyclage'
    },
    movements: {
      feed_wire: 'Virement direct',
      feed_from_free: 'Transfert depuis l’acompte libre',
      feed_from_loyalty: 'Transfert depuis la fidélité',
      feed_from_recycling: 'Transfert depuis le recyclage',
      empty_to_free: 'Vidage vers l’acompte libre',
      debit_cashback: 'Débit sur achat',
      cancel_cashback: 'Annulation d’achat'
    },
    rules: {
      special_product: 'Opération produit',
      special_global: 'Opération globale',
      product_value: 'Valeur produit',
      standard_rate: 'Taux standard'
    },
    conflicts: {
      twoGlobals: 'Deux opérations spéciales globales se chevauchent. Ce chevauchement est interdit.',
      sameProduct: 'Deux opérations spéciales se chevauchent sur le même produit. Ce chevauchement est interdit.',
      globalAndProduct: 'Une opération globale coexiste avec une opération par produit. Le plus spécifique prime. Ce n’est pas bloquant.'
    },
    overview: {
      blockedTitle: 'Subvention bloquée',
      blockedFallback: 'La subvention ne peut plus s’appliquer tant que la réserve n’est pas réalimentée.',
      gaugeTitle: 'Jauge de la réserve',
      gaugeSubtitle: 'Consommé, réserve, fallback just-in-time et budget paramétré.',
      fundCta: 'Alimenter',
      nextAction: 'Prochaine action',
      activeOps: 'Opérations en cours',
      caps: 'Plafonds proches',
      capsHint: 'Ont utilisé 80 % ou plus de leur enveloppe',
      noOps: 'Aucune opération spéciale active',
      runningOps: 'Opérations spéciales actives',
      recent: 'Derniers mouvements',
      seeAll: 'Voir l’historique',
      howTitle: 'Comment ça marche',
      how1: 'Vous définissez le taux, les plafonds et l’ordre de fallback.',
      how2: 'Vous alimentez la réserve culture depuis l’acompte, la fidélité, le recyclage ou un virement.',
      how3: 'À l’achat d’un produit éligible, la subvention est réservée 15 minutes puis débitée à la confirmation.',
      recoDisabledTitle: 'Activer la subvention',
      recoDisabledText: 'La subvention est désactivée. Les bénéficiaires ne voient pas l’avantage.',
      recoEmptyTitle: 'Alimenter la réserve',
      recoEmptyText: 'La réserve est vide. Les achats s’appuieront uniquement sur le fallback s’il est actif.',
      recoLowTitle: 'Recharger la réserve',
      recoLowText: 'Il reste moins de 15 % du budget en réserve.',
      recoCapTitle: 'Suivre les plafonds',
      recoCapText: 'Plusieurs bénéficiaires approchent de leur plafond annuel.',
      recoOkTitle: 'Rien d’urgent',
      recoOkText: 'La subvention tourne. Consultez l’historique pour le détail des mouvements.'
    },
    settings: {
      rateTitle: 'Taux de subvention standard',
      rateHint: 'Un seul taux par défaut, appliqué à tous les produits éligibles sans règle plus spécifique.',
      orderCapTitle: 'Capping par commande',
      orderCapHint: 'La subvention d’une commande ne dépasse jamais ce plafond.',
      valueModeTitle: 'Valeur par produit',
      valueModeHint: 'Si activé, certains produits peuvent porter une valeur en euros à la place du taux. Le mode « valeur unique pour tous » n’existe pas.',
      valueModeOn: 'Mode valeur activé',
      annualCapTitle: 'Capping annuel par bénéficiaire',
      annualCapHint: 'Plafond sur l’année civile. Au-delà, la subvention est appliquée au prorata du reste disponible.',
      budgetTitle: 'Budget paramétré',
      budgetHint: 'Enveloppe de référence affichée sur la jauge. Ce n’est pas un transfert de fonds.',
      fallbackTitle: 'Fallback multi-poches',
      fallbackHint: 'Aucun transfert n’est fait à l’avance. À l’achat, si la réserve ne suffit pas, les poches activées prennent le relais dans cet ordre.',
      fallbackReserve: 'Toujours utilisée en premier, dans la limite de son solde.',
      fallbackLoyalty: 'Prioritaire si la réserve ne suffit pas.',
      fallbackFree: 'Utilisée après la fidélité, ou à sa place si la fidélité est inactive.',
      fallbackRecycling: 'Dernier recours uniquement.',
      always: 'Toujours',
      statusTitle: 'Activation',
      statusHint: 'Une subvention désactivée n’apparaît plus côté bénéficiaire. Le blocage est réservé aux situations d’épuisement.',
      cancel: 'Annuler',
      save: 'Enregistrer les règles',
      saved: 'Règles enregistrées'
    },
    simulator: {
      title: 'Simuler un achat',
      subtitle: 'Le moteur applique la hiérarchie : opération produit, opération globale, valeur produit, puis taux standard.',
      product: 'Produit',
      beneficiary: 'Bénéficiaire',
      newBeneficiary: 'Bénéficiaire sans cumul',
      amount: 'Montant de la commande',
      run: 'Calculer la subvention',
      remaining: 'Reste à payer',
      subsidy: 'Subvention',
      unsaved: 'Enregistrez les règles pour que le simulateur les prenne en compte.'
    },
    funding: {
      emptyCta: 'Vider vers l’acompte libre',
      sourcesTitle: 'Alimenter la réserve',
      justInTimeTitle: 'Fallback just-in-time',
      justInTimeText: 'Activer une poche de fallback ne déplace pas les fonds. Elle ne sera débitée qu’au moment d’un achat si la réserve culture ne suffit pas.',
      wireTitle: 'Virement direct',
      wireHint: 'Utilisez cette référence dédiée pour que le virement alimente la réserve culture, pas l’acompte libre.',
      wireCard: 'Nouveau fonds, avec une référence dédiée.',
      freeCard: 'Bascule une partie de l’acompte libre vers la réserve.',
      loyaltyCard: 'Débit fidélité, crédit immédiat de la réserve.',
      recyclingCard: 'Symétrique depuis le compte de recyclage.',
      copy: 'Copier',
      copied: 'Référence copiée',
      amount: 'Montant',
      comment: 'Commentaire',
      wireSubmit: 'Enregistrer le virement',
      transferHint: 'Maximum disponible : {max}',
      transferFrom: 'Transfert depuis {pocket}',
      transferSubmit: 'Transférer vers la réserve',
      success: 'Réserve alimentée',
      emptyTitle: 'Vider la réserve',
      emptyHint: 'Les fonds retournent vers l’acompte libre, sans frais.',
      emptySubmit: 'Vider',
      emptySuccess: 'Réserve vidée vers l’acompte libre'
    },
    history: {
      search: 'Recherche (bénéficiaire, commande…)',
      type: 'Type de mouvement',
      export: 'Exporter CSV',
      empty: 'Aucun mouvement'
    },
    products: {
      readonlyTitle: 'Catalogue en lecture seule',
      readonlyText: 'L’éligibilité et les valeurs par produit sont gérées par Walleo. Vous voyez ici le taux réellement appliqué selon vos règles.',
      search: 'Rechercher un produit',
      brand: 'Enseigne',
      eligibility: 'Éligibilité',
      all: 'Tous',
      eligibleOnly: 'Éligibles',
      notEligible: 'Non éligibles',
      product: 'Produit',
      price: 'Prix CSE',
      eligible: 'Éligible',
      yes: 'Oui',
      no: 'Non',
      value: 'Valeur produit',
      applied: 'Règle appliquée'
    },
    operations: {
      readonlyTitle: 'Opérations spéciales en lecture seule',
      readonlyText: 'La création d’opérations spéciales est réservée à Walleo pour cette version.',
      warningTitle: 'Configuration à surveiller',
      timelineTitle: 'Calendrier {year}',
      create: 'Créer une opération',
      name: 'Nom',
      type: 'Nature',
      global: 'Globale',
      perProduct: 'Par produit',
      target: 'Cible',
      allCulture: 'Toute la catégorie culture',
      window: 'Fenêtre',
      boost: 'Taux / valeur',
      delete: 'Supprimer',
      product: 'Produit',
      boostMode: 'Type de majoration',
      rate: 'Taux majoré',
      value: 'Valeur majorée',
      save: 'Créer',
      created: 'Opération créée',
      incomplete: 'Renseignez le nom et la fenêtre de dates.',
      deleteConfirm: 'Supprimer cette opération spéciale ?'
    },
    beneficiaries: {
      search: 'Rechercher un bénéficiaire',
      all: 'Tous',
      near: 'Proches du plafond',
      atCap: 'Plafond atteint',
      name: 'Bénéficiaire',
      consumed: 'Cumul annuel',
      remaining: 'Reste',
      lastPurchase: 'Dernier achat'
    },
    admin: {
      title: 'Supervision subvention culture',
      subtitle: 'Suivi des caretakers, alertes, et catalogue des produits éligibles.',
      breadcrumb: 'Supervision culture',
      nav: {
        supervision: 'Supervision',
        alerts: 'Alertes',
        catalog: 'Catalogue'
      },
      caretaker: 'Caretaker',
      status: 'Statut',
      caps: 'Plafonds',
      kpiActive: 'Actives',
      kpiBlocked: 'Bloquées',
      kpiReserve: 'Réserve totale',
      kpiAlerts: 'Alertes',
      detailHint: 'Cliquez une ligne pour gérer les opérations spéciales de ce caretaker.',
      severity: {
        critical: 'Critiques',
        watch: 'Vigilance',
        info: 'Informations'
      },
      noAlerts: 'Aucune alerte dans cette catégorie'
    }
  },
  developerMode: {
    enabledTitle: 'Mode développeur activé',
    enabledMessage: 'Les fonctionnalités maquettes sont maintenant visibles.',
    disabledTitle: 'Mode développeur désactivé',
    disabledMessage: 'Les fonctionnalités maquettes ont été masquées.'
  }
}

export default translations
